// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --whot-primary: #8b5cf6;
  --whot-primary-dark: #7c3aed;
  --whot-secondary: #10b981;
  --whot-danger: #ef4444;
  --whot-warning: #f59e0b;
  --whot-dark: #0f172a;
  --whot-dark-light: #1e293b;
  --whot-light: #f8fafc;
  --whot-gray: #64748b;
  --whot-gray-light: #cbd5e1;
  --whot-radius: 16px;
  --whot-radius-sm: 10px;
  --whot-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3);
  --whot-shadow-lg: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
  --whot-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.whot-page {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: var(--whot-light);
}

.whot-shell {
  max-width: 1100px;
  margin: 0 auto;
}

.whot-header {

/* Room page: more traditional table look (mobile-friendly) */
.whot-page--room {
  padding: 12px;
  background:
    radial-gradient(1200px 520px at 50% 40%, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.70)),
    repeating-linear-gradient(90deg, #7b4a2b 0 18px, #6f4328 18px 36px),
    repeating-linear-gradient(0deg, rgba(255,255,255,0.05) 0 2px, rgba(0,0,0,0.06) 2px 4px);
}
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.whot-title {

.whot-page--room .whot-table {
  background:
    radial-gradient(900px 520px at 50% 30%, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0)),
    linear-gradient(180deg, rgba(0,0,0,0.18), rgba(0,0,0,0.30)),
    repeating-linear-gradient(90deg, #7b4a2b 0 20px, #6b4026 20px 40px);
  border-radius: 24px;
  padding: 14px;
  min-height: 0;
}
  font-size: 28px;
  margin: 0;
}

.whot-subtitle {
  margin-top: 6px;
  color: rgba(248, 250, 252, 0.75);
}

.whot-table-center-label {
  min-width: 140px;
  text-align: center;
}

.whot-table-turn {
  font-weight: 900;
  font-size: 1.35rem;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.55);
}

.whot-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--whot-radius);
  box-shadow: var(--whot-shadow);
  padding: 6px 2px;
}

.whot-opponents-row {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 4px;
  min-height: 65px;
  max-width: 100%;
}

.whot-table-toprow {
  margin-bottom: 10px;
}

.whot-opponent-panel {
  margin-top: -15px;
  margin-inline: 4px;
  padding: 0;
  background: none;
  box-shadow: none;
  width: 110px;
}


.whot-opponent-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.whot-opponent-fan {
  position: relative;
  height: 80px;
  width: 130px;
}

.whot-opponent-fan-card {
  position: absolute;
  top: 0;
  transform-origin: bottom center;
}

.whot-opponent-fan .whot-playing-card {
  cursor: default;
  transform: scale(0.5);
}

.whot-opponent-fan .whot-playing-card:hover {
  transform: scale(0.5);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.20);
}

@media (max-width: 480px) {
  .whot-page--room {
    padding: 2px;
  }

  .whot-page--room .whot-table {
    padding: 4px;
  }

  .whot-opponents-row {
    gap: 26px;
    margin-bottom: 0px;
    min-height: 65px;
    flex-wrap: wrap;
    justify-content: center;
    overflow: hidden;
  }

  .whot-opponent-fan {
    height: 80px;
    width: 100px;
  }

  .whot-playing-card {
    width: 20px;
    height: 105px;
  }

  .whot-card--in-table {
    padding: 2px 1px;
  }
}
.whot-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 980px) {
  .whot-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (orientation: portrait) and (max-width: 768px) {
  .whot-table {
    min-height: 40vh;
  }
  .whot-opponents-row {
    padding-left: 10px;
  }
}

.whot-btn {
  padding: 0.75rem 1.2rem;
  border: none;
  border-radius: 999px;
  font-weight: 700;
  cursor: pointer;
  transition: var(--whot-transition);
  color: white;
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.whot-btn:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.13);
}

.whot-btn-primary {
  background: linear-gradient(135deg, var(--whot-primary), var(--whot-primary-dark));
  border: none;
}

.whot-btn-primary:hover {
  box-shadow: 0 8px 20px rgba(139, 92, 246, 0.25);
}

.whot-btn-danger {
  background: linear-gradient(135deg, var(--whot-danger), #dc2626);
  border: none;
}

.whot-btn-danger:hover {
  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.22);
}

.whot-btn-warning {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border: none;
  color: #fff;
}

.whot-btn-warning:hover {
  box-shadow: 0 8px 20px rgba(245, 158, 11, 0.3);
}

/* Pick Two / Pick Three penalty banner */
.whot-pick-banner {
  padding: 6px 14px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.9rem;
  text-align: center;
}

.whot-pick-banner--danger {
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid #ef4444;
  color: #fca5a5;
}

/* Drawn-card hint (play it or pass) */
.whot-drawn-card-hint {
  padding: 4px 12px;
  background: rgba(245, 158, 11, 0.15);
  border: 1px solid #f59e0b;
  border-radius: 8px;
  color: #fde68a;
  font-size: 0.9rem;
  text-align: center;
}

.whot-input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: white;
  outline: none;
}

.whot-label {
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.7);
  margin-bottom: 6px;
}

.whot-row {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.whot-hand {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap !important;
  justify-content: flex-start !important;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 6px !important;
}

.whot-hand-card {
  flex: 0 0 auto;
  scroll-snap-align: center;
}

.whot-hand::-webkit-scrollbar {
  height: 6px;
}

.whot-hand::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
}

.whot-hand::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.35);
  border-radius: 999px;
}

.whot-copy-icon {
  width: 18px;
  height: 18px;
  display: block;
}

@media (max-width: 900px) and (orientation: landscape) {
  .whot-page--room {
    padding: 6px;
  }

  .whot-shell {
    max-width: 100%;
  }

  .whot-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 10px;
  }

  .whot-title {
    font-size: 20px;
  }

  .whot-room-title {
    display: none;
  }

  .whot-subtitle {
    font-size: 0.9rem;
  }

  .whot-page--room .whot-table {
    padding: 8px;
    border-radius: 16px;
  }

  .whot-opponents-row {
    gap: 4px;
    margin-bottom: 2px;
    min-height: 55px;
  }

  .whot-opponent-panel {
    width: 90px;
  }

  .whot-opponent-fan {
    height: 65px;
    width: 90px;
  }

  .whot-playing-card.is-small {
    width: 58px;
    height: 88px;
  }

  .whot-table-center {
    gap: 8px;
  }

  .whot-turn-indicator {
    font-size: 0.95rem;
    padding: 6px 10px;
  }

  .whot-room-id {
    font-size: 0.8rem;
    opacity: 0.7;
    max-width: 70vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .whot-copy-btn {
    padding: 0.35rem 0.6rem;
    min-width: 36px;
    min-height: 32px;
  }

  .whot-copy-icon {
    width: 16px;
    height: 16px;
    display: block;
  }

  .whot-controls {
    position: sticky;
    bottom: 0;
    z-index: 5;
    background: linear-gradient(180deg, rgba(15, 23, 42, 0) 0%, rgba(15, 23, 42, 0.8) 40%, rgba(15, 23, 42, 0.95) 100%);
    padding: 6px 0 10px;
  }
}

.whot-playing-card {
  width: 100px;
  height: 140px;
  border-radius: 10px;
  background: var(--whot-card-bg, #f3f4f6);
  color: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.20);
  transition: var(--whot-transition);
  cursor: pointer;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  border: 1px solid #d1d5db;
  isolation: isolate;
}

.whot-playing-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.28);
}

.whot-playing-card.selected {
  transform: translateY(-18px);
  box-shadow: 0 0 0 3px var(--whot-card-color, var(--whot-primary));
}

.whot-playing-card.is-small {
  width: 70px;
  height: 105px;
}

/* =============================== */
/* Photo/traditional Whot face (scoped) */
/* =============================== */
.whot-playing-card--photo {
  background: #ffffff;
  border: 1.5px solid #c7ceda;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
}

.whot-playing-card--photo::before {
  content: '';
  position: absolute;
  inset: 6px;
  border-radius: 8px;
  border: 1px solid rgba(30, 41, 59, 0.18);
  pointer-events: none;
}

.whot-playing-card--photo {
  --whot-ink-red: var(--whot-card-color, #9B0F0F);
}

.whot-playing-card--photo .photo-corner {
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  color: var(--whot-ink-red);
  font-family: 'Arial Black', 'Segoe UI', system-ui, sans-serif;
  font-weight: 900;
  line-height: 1;
  z-index: 3;
}

.whot-playing-card--photo .photo-corner-number {
  font-size: 1.6rem;
  letter-spacing: -0.02em;
}

.whot-playing-card--photo.is-small .photo-corner-number {
  font-size: 1.1rem;
}

.whot-playing-card--photo .photo-corner-symbol {
  width: 16px;
  height: 16px;
  display: inline-flex;
}

.whot-playing-card--photo.is-small .photo-corner-symbol {
  width: 12px;
  height: 12px;
}

.whot-playing-card--photo .photo-corner-w {
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-weight: 900;
  font-style: italic;
  font-size: 1.1rem;
  transform: translateY(1px);
}

.whot-playing-card--photo.is-small .photo-corner-w {
  font-size: 0.85rem;
}

.whot-playing-card--photo .photo-corner--tl { top: 8px; left: 8px; align-items: flex-start; flex-direction: column-reverse; }
.whot-playing-card--photo .photo-corner--tr { top: 8px; right: 8px; align-items: flex-end; }
.whot-playing-card--photo .photo-corner--bl { bottom: 8px; left: 8px; transform: rotate(180deg); align-items: flex-start; }
.whot-playing-card--photo .photo-corner--br { bottom: 8px; right: 8px; transform: rotate(180deg); align-items: flex-start; flex-direction: column-reverse; }

/* Circle 10–14: the bottom-right small circle can crowd the center mark */
.whot-playing-card--photo.shape-circle[data-number="10"] .photo-corner--br,
.whot-playing-card--photo.shape-circle[data-number="11"] .photo-corner--br,
.whot-playing-card--photo.shape-circle[data-number="12"] .photo-corner--br,
.whot-playing-card--photo.shape-circle[data-number="13"] .photo-corner--br,
.whot-playing-card--photo.shape-circle[data-number="14"] .photo-corner--br {
  gap: 0px;
}

.whot-playing-card--photo .photo-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.whot-playing-card--photo .photo-center-symbol {
  width: 82px;
  height: 82px;
  display: inline-flex;
}

.whot-playing-card--photo .photo-center-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Arial Black', 'Segoe UI', system-ui, sans-serif;
  font-weight: 900;
  font-size: 1.8rem;
  letter-spacing: -0.04em;
  color: #ffffff;
  text-shadow: 0 2px 6px rgba(15, 23, 42, 0.45);
  line-height: 1;
  z-index: 2;
  pointer-events: none;
}

.whot-playing-card--photo.is-small .photo-center-number {
  font-size: 1.2rem;
  letter-spacing: -0.05em;
}

/* Some high-number circle/triangle cards need a slightly smaller center mark */
.whot-playing-card--photo.shape-circle[data-number="10"] .photo-center-symbol,
.whot-playing-card--photo.shape-circle[data-number="11"] .photo-center-symbol,
.whot-playing-card--photo.shape-circle[data-number="12"] .photo-center-symbol {
  width: 74px;
  height: 74px;
}

.whot-playing-card--photo.shape-circle[data-number="13"] .photo-center-symbol,
.whot-playing-card--photo.shape-circle[data-number="14"] .photo-center-symbol {
  width: 72px;
  height: 72px;
}

.whot-playing-card--photo.shape-square[data-number="3"] .photo-center-symbol,
.whot-playing-card--photo.shape-square[data-number="11"] .photo-center-symbol,
.whot-playing-card--photo.shape-square[data-number="10"] .photo-center-symbol,
.whot-playing-card--photo.shape-square[data-number="13"] .photo-center-symbol,
.whot-playing-card--photo.shape-square[data-number="14"] .photo-center-symbol {
  width: 72px;
  height: 72px;
}

.whot-playing-card--photo.shape-triangle[data-number="3"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="4"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="5"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="7"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="8"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="10"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="11"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="12"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="13"] .photo-center-symbol,
.whot-playing-card--photo.shape-triangle[data-number="14"] .photo-center-symbol {
  width: 72px;
  height: 72px;
}

.whot-playing-card--photo.is-small.shape-circle[data-number="10"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-circle[data-number="11"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-circle[data-number="12"] .photo-center-symbol {
  width: 54px;
  height: 54px;
}

.whot-playing-card--photo.is-small.shape-circle[data-number="13"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-circle[data-number="14"] .photo-center-symbol {
  width: 52px;
  height: 52px;
}

.whot-playing-card--photo.is-small.shape-square[data-number="3"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-square[data-number="11"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-square[data-number="10"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-square[data-number="13"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-square[data-number="14"] .photo-center-symbol {
  width: 52px;
  height: 52px;
}

.whot-playing-card--photo.is-small.shape-triangle[data-number="3"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="4"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="5"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="7"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="8"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="10"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="11"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="12"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="13"] .photo-center-symbol,
.whot-playing-card--photo.is-small.shape-triangle[data-number="14"] .photo-center-symbol {
  width: 52px;
  height: 52px;
}

.whot-playing-card--photo.is-small .photo-center-symbol {
  width: 60px;
  height: 60px;
}

.whot-playing-card--photo .photo-whot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: var(--whot-ink-red);
}

.whot-playing-card--photo .photo-whot-text {
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-size: 1.65rem;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.whot-playing-card--photo.is-small .photo-whot-text {
  font-size: 1.2rem;
}

.whot-playing-card--photo .photo-whot-w {
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-style: italic;
  font-weight: 900;
  font-size: 1.15rem;
  line-height: 1;
}

.whot-playing-card--photo .photo-whot-w--flip {
  transform: rotate(180deg);
}

.whot-playing-card--photo.is-small .photo-whot-w {
  font-size: 0.9rem;
}

/* =============================== */
/* example.html card design (scoped) */
/* =============================== */
.whot-playing-card--example {
  background: #ffffff;
  border: 2px solid #1e293b;
}

.whot-playing-card--example .corner-number {
  position: absolute;
  font-size: 1.8rem;
  font-weight: 900;
  color: #1e293b;
  font-family: 'Arial Black', 'Segoe UI', sans-serif;
}

.whot-playing-card--example.is-small .corner-number {
  font-size: 1.2rem;
}

.whot-playing-card--example .corner-number.tl { top: 8px; left: 8px; }
.whot-playing-card--example .corner-number.tr { top: 8px; right: 8px; }
.whot-playing-card--example .corner-number.bl { bottom: 8px; left: 8px; transform: rotate(180deg); }
.whot-playing-card--example .corner-number.br { bottom: 8px; right: 8px; transform: rotate(180deg); }

.whot-playing-card--example .card-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 80%;
}

.whot-playing-card--example:not(.is-whot) .shape-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.whot-playing-card--example:not(.is-whot) .shape-symbol {
  font-size: 4.5rem;
  position: absolute;
  color: var(--shape-color, #1e293b);
  opacity: 0.9;
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.whot-playing-card--example.is-small:not(.is-whot) .shape-symbol {
  font-size: 3rem;
}

.whot-playing-card--example:not(.is-whot) .center-number {
  position: absolute;
  font-size: 2.2rem;
  font-weight: 900;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  z-index: 2;
  font-family: 'Arial Black', 'Segoe UI', sans-serif;
}

.whot-playing-card--example.is-small:not(.is-whot) .center-number {
  font-size: 1.5rem;
}

/* WHOT (20) */
.whot-playing-card--example.is-whot {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  border-color: #d97706;
}

.whot-playing-card--example.is-whot .corner-number {
  color: #92400e;
}

.whot-playing-card--example.is-whot .whot-star {
  font-size: 4.5rem;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  animation: whot-pulse 2s infinite;
}

.whot-playing-card--example.is-small.is-whot .whot-star {
  font-size: 3rem;
}

.whot-playing-card--example.is-whot .whot-text {
  position: absolute;
  top: calc(50% + 25px);
  left: 50%;
  transform: translateX(-50%);
  font-size: 1.4rem;
  font-weight: 900;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
  background: rgba(146, 64, 14, 0.8);
  padding: 4px 12px;
  border-radius: 20px;
  white-space: nowrap;
}

.whot-playing-card--example.is-small.is-whot .whot-text {
  font-size: 1rem;
  top: calc(50% + 18px);
  padding: 3px 8px;
}

@keyframes whot-pulse {
  0%, 100% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -50%) scale(1.1); }
}

/* Classic (pre-photo) card face */
.whot-playing-card--classic {
  background: var(--whot-card-bg, #f3f4f6);
  border: 2px solid #0b1220;
}

.whot-playing-card--classic::before {
  content: '';
  position: absolute;
  inset: 5px;
  border-radius: 7px;
  border: 1px solid rgba(17, 24, 39, 0.22);
  pointer-events: none;
}

.whot-playing-card--classic .corner {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  z-index: 2;
  font-family: Georgia, "Times New Roman", Times, serif;
}

.whot-playing-card--classic .corner-top-left { top: 8px; left: 8px; align-items: flex-start; }
.whot-playing-card--classic .corner-top-right { top: 8px; right: 8px; align-items: flex-end; }
.whot-playing-card--classic .corner-bottom-left { bottom: 8px; left: 8px; align-items: flex-start; transform: rotate(180deg); }
.whot-playing-card--classic .corner-bottom-right { bottom: 8px; right: 8px; align-items: flex-end; transform: rotate(180deg); }

.whot-playing-card--classic .corner-number {
  font-size: 1.75rem;
  font-weight: 900;
  line-height: 1;
}

.whot-playing-card--classic.is-small .corner-number { font-size: 1.2rem; }

.whot-playing-card--classic .corner-suit {
  font-size: 1.25rem;
  font-weight: 900;
  line-height: 1;
}

.whot-playing-card--classic.is-small .corner-suit { font-size: 0.95rem; }

.whot-playing-card--classic .card-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  z-index: 1;
}

.whot-playing-card--classic .shape-symbol {
  font-size: 4rem;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.10);
}

.whot-playing-card--classic.is-small .shape-symbol { font-size: 2.9rem; }

.whot-playing-card--classic .whot-center-number {
  position: absolute;
  font-size: 1.6rem;
  font-weight: 900;
  text-shadow: 0 2px 6px rgba(0,0,0,0.35);
}

.whot-playing-card--classic.is-small .whot-center-number { font-size: 1.25rem; }

/* Traditional Nigerian Whot layout */
.whot-playing-card--traditional {
  --whot-ink-red: var(--whot-card-color, #9B0F0F);
  background: var(--whot-card-bg, #f3f4f6);
  border: 2px solid #0b1220;
}

.whot-playing-card--traditional::before {
  content: '';
  position: absolute;
  inset: 5px;
  border-radius: 7px;
  border: 1px solid rgba(17, 24, 39, 0.22);
  pointer-events: none;
}

.whot-playing-card--traditional .whot-corner {
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: var(--whot-ink-red);
  font-weight: 900;
  z-index: 3;
}

.whot-playing-card--traditional .whot-corner--tl {
  top: 8px;
  left: 8px;
}

.whot-playing-card--traditional .whot-corner--br {
  bottom: 8px;
  right: 8px;
  transform: rotate(180deg);
}

.whot-playing-card--traditional .whot-corner-number {
  font-size: 1.8rem;
  line-height: 1;
  font-family: Georgia, "Times New Roman", Times, serif;
  text-shadow: 0 1px 0 rgba(255,255,255,0.7);
}

.whot-playing-card--traditional.is-small .whot-corner-number {
  font-size: 1.15rem;
}

.whot-playing-card--traditional .whot-corner-symbol {
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Triangle corner symbols are offset in the traditional deck */
.whot-playing-card--traditional.shape-triangle .whot-corner {
  width: 34px;
  height: 48px;
}

.whot-playing-card--traditional.shape-triangle.is-small .whot-corner {
  width: 28px;
  height: 42px;
}

.whot-playing-card--traditional.shape-triangle .whot-corner-symbol {
  position: absolute;
}

/* top-left: small triangle sits by the top angle (to the side) */
.whot-playing-card--traditional.shape-triangle .whot-corner--tl .whot-corner-symbol {
  right: -2px;
  top: 22px;
}

/* bottom-right: small triangle sits closer to the baseline */
.whot-playing-card--traditional.shape-triangle .whot-corner--br .whot-corner-symbol {
  left: -2px;
  top: 26px;
}

.whot-playing-card--traditional.shape-triangle.is-small .whot-corner--tl .whot-corner-symbol {
  right: -2px;
  top: 18px;
}

.whot-playing-card--traditional.shape-triangle.is-small .whot-corner--br .whot-corner-symbol {
  left: -2px;
  top: 22px;
}

.whot-playing-card--traditional .whot-corner-symbol svg {
  display: block;
}

.whot-playing-card--traditional.is-small .whot-corner-symbol {
  font-size: 0.95rem;
}

.whot-playing-card--traditional .whot-center-shape {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.whot-playing-card--traditional .whot-center-symbol {
  width: 78px;
  height: 78px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.whot-playing-card--traditional.is-small .whot-center-symbol {
  width: 58px;
  height: 58px;
}

.whot-playing-card--traditional.is-small .whot-center-symbol {
  font-size: 3.6rem;
}

.whot-playing-card--traditional .whot-center-number {
  position: absolute;
  color: #ffffff;
  font-weight: 900;
  font-size: 2.1rem;
  letter-spacing: 0.02em;
  text-shadow: 0 2px 6px rgba(0,0,0,0.35);
  font-family: Georgia, "Times New Roman", Times, serif;
  z-index: 2;
}

/* STAR cards: smaller doubled-number inside the star */
.whot-playing-card--traditional.shape-star .whot-center-number {
  font-size: 1.75rem;
}

.whot-playing-card--traditional.shape-star.is-small .whot-center-number {
  font-size: 1.35rem;
}

.whot-playing-card--traditional.is-small .whot-center-number {
  font-size: 1.55rem;
}


.whot-playing-card--traditional .whot-whot-stack {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.whot-playing-card--traditional .whot-whot-word {
  font-family: Georgia, "Times New Roman", Times, serif;
  font-weight: 900;
  font-size: 1.55rem;
  letter-spacing: 0.08em;
  color: rgba(255,255,255,0.9);
  -webkit-text-stroke: 3px var(--whot-ink-red);
  paint-order: stroke fill;
  text-shadow: 0 1px 0 rgba(255,255,255,0.4);
}

.whot-playing-card--traditional .whot-whot-word--flip {
  transform: rotate(180deg);
}

.whot-playing-card--traditional.is-small .whot-whot-word {
  font-size: 1.15rem;
  -webkit-text-stroke: 2.5px var(--whot-ink-red);
}

/* New card face layout (ported from example.html) */
.whot-playing-card .corner {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, "Noto Sans", "Liberation Sans", sans-serif;
}

.whot-playing-card .corner-top-left {
  top: 8px;
  left: 8px;
  align-items: flex-start;
}

.whot-playing-card .corner-top-right {
  top: 8px;
  right: 8px;
  align-items: flex-end;
}

.whot-playing-card .corner-bottom-left {
  bottom: 8px;
  left: 8px;
  align-items: flex-start;
}

.whot-playing-card .corner-bottom-right {
  bottom: 8px;
  right: 8px;
  align-items: flex-end;
}

.whot-playing-card .corner-number {
  font-size: 1.8rem;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 2px;
}

.whot-playing-card.is-small .corner-number {
  font-size: 1.25rem;
}

.whot-playing-card .corner-suit {
  font-size: 1.1rem;
  font-weight: 900;
  line-height: 1;
}

.whot-playing-card.is-small .corner-suit {
  font-size: 0.9rem;
}

.whot-playing-card .corner-bottom-left,
.whot-playing-card .corner-bottom-right {
  transform: rotate(180deg);
}

.whot-playing-card .card-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
}

.whot-playing-card .shape-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.whot-playing-card .shape-symbol {
  font-size: 4rem;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.10);
  font-family: "Georgia", "Times New Roman", Times, serif;
}

.whot-playing-card.is-small .shape-symbol {
  font-size: 2.7rem;
}

.whot-playing-card .whot-card-label {
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  font-size: 0.62rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.10);
  max-width: 88%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.whot-playing-card.is-small .whot-card-label {
  font-size: 0.52rem;
  bottom: 10px;
}

.whot-playing-card .whot-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.whot-playing-card .whot-star {
  font-size: 4.2rem;
  line-height: 1;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.16);
  animation: whot-pulse 2s infinite;
}

.whot-playing-card.is-small .whot-star {
  font-size: 2.9rem;
}

@keyframes whot-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.07); }
}

.whot-playing-card .whot-text {
  font-size: 1.5rem;
  font-weight: 900;
  letter-spacing: 2px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.18);
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, "Noto Sans", "Liberation Sans", sans-serif;
}

.whot-playing-card.is-small .whot-text {
  font-size: 1.05rem;
  letter-spacing: 1.2px;
}

.whot-playing-card .selected-glow {
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border: 3px solid;
  border-radius: 12px;
  animation: whot-glow 1.5s ease-in-out infinite alternate;
  pointer-events: none;
}

@keyframes whot-glow {
  from { box-shadow: 0 0 10px currentColor; }
  to { box-shadow: 0 0 20px currentColor; }
}

.whot-playing-card .playable-indicator {
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 12px;
  opacity: 0.10;
  pointer-events: none;
}

/* Face-down variant for deck cards */
.whot-playing-card.face-down {
  background: linear-gradient(135deg, #5B0909 0%, #9B0F0F 55%, #B61414 100%);
  border-color: rgba(255, 255, 255, 0.58);
}

.whot-playing-card.face-down:hover {
  transform: translateY(-6px);
}

.whot-playing-card.face-down .card-back-pattern {
  position: absolute;
  inset: 0;
  background: none;
}

.whot-playing-card.face-down .card-back-logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(255, 255, 255, 0.92);
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-size: 1.55rem;
  font-weight: 900;
  letter-spacing: 0.04em;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.whot-playing-card.face-down.is-small .card-back-logo {
  font-size: 1.05rem;
}

.whot-playing-card.face-down .back-dot {
  display: none;
}

.whot-playing-card .whot-card-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.35);
  color: rgba(255, 255, 255, 0.95);
  padding: 4px 8px;
  border-radius: 999px;
  font-weight: 900;
  font-size: 0.95rem;
  border: 1px solid rgba(255, 255, 255, 0.22);
}

.whot-playing-card.is-small .whot-card-badge {
  font-size: 0.8rem;
  padding: 3px 7px;
}

@media (max-width: 360px) {
  .whot-playing-card {
    width: 42px;
    height: 61px;
  }

  .whot-playing-card.is-small {
    width: 36px;
    height: 52px;
  }

  .whot-playing-card:hover {
    transform: translateY(-6px);
  }

  .whot-playing-card.selected {
    transform: translateY(-10px);
  }

  .whot-table {
    padding: 0.6rem;
    min-height: 250px;
  }

  .whot-table-center {
    gap: 14px;
  }

  .whot-hand {
    gap: 4px;
    padding: 0.4rem;
  }

  .whot-playing-card--photo::before {
    inset: 5px;
  }

  .whot-playing-card--photo .photo-corner--tl { top: 6px; left: 6px; }
  .whot-playing-card--photo .photo-corner--br { bottom: 6px; right: 6px; }

  .whot-playing-card--photo .photo-corner-number {
    font-size: 1.2rem;
  }

  .whot-playing-card--photo .photo-corner-symbol {
    width: 12px;
    height: 12px;
  }

  .whot-playing-card--photo .photo-corner-w {
    font-size: 0.9rem;
  }

  .whot-playing-card--photo .photo-center-symbol {
    width: 60px;
    height: 60px;
  }

  .whot-playing-card--photo.shape-circle[data-number="10"] .photo-center-symbol,
  .whot-playing-card--photo.shape-circle[data-number="11"] .photo-center-symbol,
  .whot-playing-card--photo.shape-circle[data-number="12"] .photo-center-symbol {
    width: 56px;
    height: 56px;
  }

  .whot-playing-card--photo.shape-circle[data-number="13"] .photo-center-symbol,
  .whot-playing-card--photo.shape-circle[data-number="14"] .photo-center-symbol {
    width: 54px;
    height: 54px;
  }

  .whot-playing-card--photo.shape-square[data-number="3"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="10"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="11"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="13"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="14"] .photo-center-symbol {
    width: 54px;
    height: 54px;
  }

  .whot-playing-card--photo.shape-triangle[data-number="3"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="4"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="5"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="7"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="8"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="10"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="11"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="12"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="13"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="14"] .photo-center-symbol {
    width: 54px;
    height: 54px;
  }

  .whot-playing-card--photo .photo-whot-text {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .whot-page {
    padding: 10px;
  }

  .whot-playing-card {
    width: 52px;
    height: 74px;
  }

  .whot-playing-card.is-small {
    width: 44px;
    height: 62px;
  }

  .whot-table {
    padding: 0.75rem;
    min-height: 45vh;
  }

  .whot-table-center {
    gap: 10px;
  }

  /* Horizontal scroll hand so lots of cards still fit */

  .whot-hand {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding: 0.3rem 0.5vw 0.5rem 0.5vw;
    gap: 8px;
    -webkit-overflow-scrolling: touch;
    background: none;
    box-shadow: none;
    min-height: 0;
  }

  @media (max-width: 600px) {
    .whot-hand {
      position: sticky;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 20;
      background: rgba(30,40,80,0.97);
      border-radius: 0;
      box-shadow: 0 -2px 12px 0 rgba(0,0,0,0.12);
      padding-bottom: env(safe-area-inset-bottom, 0.5rem);
      margin-bottom: 0;
    }
    .whot-table {
      padding-bottom: 80px;
    }
  }

  .whot-hand > .whot-playing-card {
    flex: 0 0 auto;
  }

  .whot-playing-card--photo .photo-corner-number {
    font-size: 1rem;
  }

  .whot-playing-card--photo .photo-center-symbol {
    width: 44px;
    height: 44px;
  }

  .whot-playing-card--photo.shape-circle[data-number="10"] .photo-center-symbol,
  .whot-playing-card--photo.shape-circle[data-number="11"] .photo-center-symbol,
  .whot-playing-card--photo.shape-circle[data-number="12"] .photo-center-symbol {
    width: 40px;
    height: 40px;
  }

  .whot-playing-card--photo.shape-circle[data-number="13"] .photo-center-symbol,
  .whot-playing-card--photo.shape-circle[data-number="14"] .photo-center-symbol {
    width: 40px;
    height: 40px;
  }

  .whot-playing-card--photo.shape-square[data-number="3"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="10"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="11"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="13"] .photo-center-symbol,
  .whot-playing-card--photo.shape-square[data-number="14"] .photo-center-symbol {
    width: 40px;
    height: 40px;
  }

  .whot-playing-card--photo.shape-triangle[data-number="3"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="4"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="5"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="7"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="8"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="10"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="11"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="12"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="13"] .photo-center-symbol,
  .whot-playing-card--photo.shape-triangle[data-number="14"] .photo-center-symbol {
    width: 40px;
    height: 40px;
  }

  .whot-playing-card--photo .photo-whot-text {
    font-size: 1.1rem;
  }
}

/* a11y helper */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Card flight animation (deck → hand, hand → pile) */
.whot-flight-layer {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
}

.whot-flight-card {
  position: fixed;
  transform-origin: top left;
  will-change: transform, opacity;
  filter: drop-shadow(0 12px 18px rgba(0, 0, 0, 0.35));
}

.whot-hand-card {
  display: inline-block;
}



.whot-table {
  background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
  border-radius: 20px;
  padding: 1.2rem;
  position: relative;
  min-height: 50vh;
  border: 2px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.whot-table-corner {
  position: absolute;
  top: 10px;
  left: 10px;
  display: grid;
  gap: 1px;
  padding: 4px 8px;
  border-radius: 10px;
  background: rgba(8, 12, 35, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
  z-index: 2;
}

.whot-table-corner-title {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.7);
}

.whot-table-corner-value {
  font-size: 0.95rem;
  font-weight: 800;
  color: #f8fafc;
}

.whot-table-corner-timer {
  font-size: 0.85rem;
  font-weight: 700;
  color: #93c5fd;
}

.whot-table-left-banner {
  position: absolute;
  top: 52%;
  left: -2px;
  transform: translateY(-50%);
  z-index: 2;
  padding: 4px 8px;
  font-size: 0.8rem;
  max-width: 180px;
  pointer-events: none;
}

@media (max-width: 900px) and (orientation: landscape) {
  .whot-table-corner {
    top: 40%;
    left: 6px;
    transform: translateY(-50%);
    padding: 3px 6px;
  }

  .whot-table-corner-value {
    font-size: 0.85rem;
  }

  .whot-table-corner-timer {
    font-size: 0.75rem;
  }

  .whot-table-left-banner {
    top: 56%;
    left: -4px;
    font-size: 0.75rem;
    transform: translateY(-50%);
    max-width: 155px;
  }

  .whot-table .whot-controls {
    position: absolute;
    top: 44%;
    right: 8px;
    transform: translateY(-50%);
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin: 0;
    background: transparent;
    padding: 0;
  }

  .whot-control-btn {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .whot-btn-text {
    display: none;
  }

  .whot-btn-icon {
    display: inline-flex;
    width: 18px;
    height: 18px;
  }

  .whot-controls .whot-pick-banner {
    display: none;
  }
}

.whot-btn-icon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  color: currentColor;
}

.whot-btn-text {
  display: none;
}

.whot-table-center {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  align-items: center;
}

.whot-turn-indicator {
  min-width: 120px;
  text-align: center;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 900;
  font-size: 1.35rem;
  letter-spacing: 0.02em;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.55);
  -webkit-user-select: none;
          user-select: none;
}

@media (max-width: 768px) {
  .whot-turn-indicator {
    min-width: 96px;
    font-size: 1.15rem;
  }
}

@media (max-width: 480px) {
  .whot-turn-indicator {
    min-width: 84px;
    font-size: 1.05rem;
  }
}

.whot-table-playzone {
  margin-top: 10px;
}

.whot-card--in-table {
  padding: 10px;
  box-shadow: none;
  background: rgba(255, 255, 255, 0.05);
}

.whot-table .whot-hand {
  padding: 0.65rem 0.5rem;
  gap: 8px;
}

.whot-deck {
  width: 100px;
  height: 140px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.whot-deck::after {
  content: 'WHOT';
  color: white;
  font-size: 1.35rem;
  font-weight: 900;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.whot-deck-count {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.35);
  padding: 4px 8px;
  border-radius: 999px;
  font-weight: 800;
}

.whot-hand {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0.5rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: var(--whot-radius);
  margin-top: 14px;
}

/* Preview page */
.whot-preview-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(75px, 1fr));
  gap: 12px;
}

.whot-preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.whot-preview-caption {
  font-size: 12px;
  color: rgba(248, 250, 252, 0.75);
  text-align: center;
}

@media (max-width: 480px) {
  .whot-preview-grid {
    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    gap: 10px;
  }
}

.whot-shape-options {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.whot-shape-option {
  width: 46px;
  height: 46px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  cursor: pointer;
  color: white;
  font-size: 20px;
  font-weight: 800;
}

.whot-muted {
  color: rgba(248, 250, 252, 0.75);
}

.whot-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.10);
  font-weight: 700;
  font-size: 12px;
}

.whot-scoreboard {
  margin-top: 14px;
  padding: 14px;
  border-radius: var(--whot-radius);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.whot-score-list {
  margin-top: 10px;
  display: grid;
  gap: 8px;
}

.whot-score-item {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.whot-score-item--rank-1 {
  border-color: rgba(34, 197, 94, 0.6);
  background: rgba(34, 197, 94, 0.12);
}

.whot-score-item--rank-2 {
  border-color: rgba(251, 191, 36, 0.5);
  background: rgba(251, 191, 36, 0.12);
}

/* WHOT lobby board polish */
.whot-lobby-create {
  background: linear-gradient(145deg, rgba(15, 23, 42, 0.72), rgba(17, 24, 39, 0.68));
}

.whot-lobby-limit {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(2, 6, 23, 0.35);
}

.whot-lobby-section {
  padding: 14px;
}

.whot-lobby-room {
  background: rgba(2, 6, 23, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

/* Redesigned WHOT lobby layout */
.whot-lobby-container {
  min-height: 100vh;
  position: relative;
  overflow-x: clip;
  padding: 22px;
  background: radial-gradient(900px 480px at 10% -5%, rgba(139, 92, 246, 0.25), transparent 60%),
    radial-gradient(700px 420px at 92% 4%, rgba(16, 185, 129, 0.18), transparent 60%),
    linear-gradient(140deg, #0b1223, #121b2e);
}

.whot-lobby-container {
  color: #f8fafc;
}

.whot-lobby-container h1,
.whot-lobby-container h2,
.whot-lobby-container h3,
.whot-lobby-container h4,
.whot-lobby-container p,
.whot-lobby-container span,
.whot-lobby-container label,
.whot-lobby-container strong,
.whot-lobby-container button {
  color: inherit;
}

.whot-lobby-container,
.whot-lobby-container *,
.whot-lobby-container *::before,
.whot-lobby-container *::after {
  box-sizing: border-box;
}

.whot-bg-animation {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.whot-card-glow {
  position: absolute;
  width: 320px;
  height: 320px;
  border-radius: 999px;
  filter: blur(75px);
  opacity: 0.4;
  left: -70px;
  top: 18%;
  background: rgba(139, 92, 246, 0.7);
  animation: whot-lobby-float 14s ease-in-out infinite;
}

.whot-card-glow.delay-1 {
  left: auto;
  right: -90px;
  top: -40px;
  background: rgba(14, 165, 233, 0.64);
  animation-delay: 3s;
}

.whot-card-glow.delay-2 {
  left: 45%;
  top: 72%;
  width: 260px;
  height: 260px;
  background: rgba(16, 185, 129, 0.54);
  animation-delay: 6s;
}

@keyframes whot-lobby-float {
  0%, 100% { transform: translate3d(0, 0, 0) scale(1); }
  50% { transform: translate3d(20px, -16px, 0) scale(1.06); }
}

.whot-lobby-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 18px;
}

.whot-lobby-content > * {
  width: 100%;
  min-width: 0;
}

.whot-lobby-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.whot-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-size: 24px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.whot-lobby-title {
  margin: 0;
  font-size: clamp(1.45rem, 2.8vw, 2rem);
}

.whot-lobby-subtitle {
  margin: 4px 0 0;
  color: rgba(248, 250, 252, 0.76);
}

.sound-toggle {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
}

.stats-cards,
.quick-actions-grid,
.challenges-grid {
  display: grid;
  gap: 12px;
}

.stats-cards {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.stat-card,
.quick-actions-section,
.create-section,
.challenges-section,
.create-modal {
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(7, 12, 24, 0.74);
  backdrop-filter: blur(8px);
}

.stat-card {
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.stat-label { color: rgba(248, 250, 252, 0.74); font-size: 12px; }
.stat-value { font-weight: 800; font-size: 1.1rem; }

.error-alert {
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.6);
  background: rgba(239, 68, 68, 0.12);
  color: #fecaca;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-close {
  margin-left: auto;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 18px;
  cursor: pointer;
}

.quick-actions-section,
.create-section,
.challenges-section {
  padding: 16px;
}

.quick-actions-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.challenges-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }

.section-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.section-title {
  margin: 0;
  font-size: 1.18rem;
}

.section-subtitle {
  margin: 0;
  color: rgba(248, 250, 252, 0.72);
  font-size: 0.94rem;
}

.action-card {
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  color: #eef2ff;
  padding: 12px;
  min-width: 0;
}

.action-card:not(.join-code) {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
}

.action-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.16);
  flex: 0 0 auto;
}

.action-info {
  min-width: 0;
}

.action-title {
  font-weight: 700;
}

.action-desc {
  margin-top: 2px;
  color: rgba(248, 250, 252, 0.72);
  font-size: 0.88rem;
}

.action-card.quick-match { background: linear-gradient(140deg, rgba(16, 185, 129, 0.22), rgba(16, 185, 129, 0.08)); }
.action-card.cancel-match { background: linear-gradient(140deg, rgba(239, 68, 68, 0.24), rgba(239, 68, 68, 0.09)); }

.join-code { display: grid; gap: 8px; }
.join-input { width: 100%; }
.join-btn { width: 100%; }

.code-input,
.filter-select,
.search-input,
.form-input,
.form-select {
  width: 100%;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(2, 6, 23, 0.48);
  color: #f8fafc;
  padding: 10px 12px;
}

.filter-select,
.form-select {
  color-scheme: dark;
}

.filter-select option,
.form-select option {
  background: #0f172a;
  color: #f8fafc;
}

.code-hint,
.form-hint {
  color: rgba(191, 219, 254, 0.85);
  font-size: 0.84rem;
}

.create-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.create-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.06);
  color: #f8fafc;
  padding: 12px;
  text-align: left;
}

.create-card.real {
  border-color: rgba(250, 204, 21, 0.45);
}

.create-title {
  font-weight: 700;
}

.create-desc {
  color: rgba(248, 250, 252, 0.74);
  font-size: 0.88rem;
}

.limit-warning {
  margin-top: 10px;
  border-radius: 10px;
  border: 1px solid rgba(245, 158, 11, 0.45);
  background: rgba(245, 158, 11, 0.12);
  padding: 10px 12px;
  color: #fde68a;
}

.challenge-card {
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(2, 6, 23, 0.36);
  padding: 12px;
  min-width: 0;
}

.challenge-header,
.challenge-actions,
.filters-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.challenge-stats {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

/* Keep WHOT lobby room stats readable even when global .stat styles are loaded */
.whot-lobby-container .challenge-stats .stat {
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 10px;
  padding: 8px 10px;
  text-align: left;
}

.whot-lobby-container .challenge-stats .stat .stat-label {
  color: rgba(226, 232, 240, 0.88);
  font-size: 0.78rem;
}

.whot-lobby-container .challenge-stats .stat .stat-value {
  color: #f8fafc;
  font-size: 0.96rem;
  font-weight: 800;
}

.whot-lobby-container .challenge-stats .stat .stat-value.highlight {
  color: #fde68a;
}

.challenge-rules,
.challenge-host {
  margin-top: 8px;
  color: rgba(226, 232, 240, 0.82);
  font-size: 0.9rem;
}

.challenge-badge {
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 800;
}

.challenge-badge.friendly {
  background: rgba(56, 189, 248, 0.2);
  color: #7dd3fc;
}

.challenge-badge.real {
  background: rgba(239, 68, 68, 0.2);
  color: #fecaca;
}

.action-btn {
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
  cursor: pointer;
}

.action-btn.play { background: linear-gradient(140deg, #22c55e, #16a34a); }
.action-btn.watch { background: linear-gradient(140deg, #38bdf8, #0284c7); }
.action-btn.cancel { background: linear-gradient(140deg, #ef4444, #b91c1c); }

.action-btn.disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.modal-container {
  width: min(760px, calc(100vw - 18px));
  max-height: min(90vh, 880px);
  overflow: auto;
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: linear-gradient(165deg, #0f172a 0%, #111827 55%, #0b1220 100%);
  color: #f8fafc;
}

.modal-container .form-select,
.modal-container .filter-select {
  background-color: #0f172a !important;
  color: #f8fafc !important;
}

.modal-container .form-select option,
.modal-container .filter-select option {
  background-color: #0f172a !important;
  color: #f8fafc !important;
}

.modal-container .form-label,
.modal-container .form-hint,
.modal-container .rule-checkbox,
.modal-container .rule-checkbox span,
.modal-container .form-input,
.modal-container .form-select,
.modal-container .form-input::placeholder {
  color: #f8fafc;
}

.modal-header,
.modal-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px;
}

.modal-header {
  border-bottom: 1px solid rgba(148, 163, 184, 0.22);
}

.modal-body {
  padding: 14px;
  display: grid;
  gap: 10px;
}

.whot-create-modal .modal-body {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
}

.whot-create-modal .modal-body .form-group--full {
  grid-column: 1 / -1;
}

.modal-title {
  margin: 0;
}

.modal-close {
  margin-left: auto;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  font-size: 20px;
  cursor: pointer;
}

.btn-create,
.btn-cancel {
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
}

.btn-create {
  flex: 2 1;
  background: linear-gradient(140deg, #22c55e, #16a34a);
  color: #fff;
  font-weight: 800;
}

.btn-cancel {
  flex: 1 1;
  background: linear-gradient(140deg, #ef4444, #b91c1c);
  color: #fff;
}

.empty-state {
  border-radius: 12px;
  border: 1px dashed rgba(148, 163, 184, 0.4);
  background: rgba(15, 23, 42, 0.4);
  padding: 20px;
  text-align: center;
}

.empty-title {
  margin-top: 6px;
  font-weight: 800;
}

.empty-desc {
  margin-top: 4px;
  color: rgba(226, 232, 240, 0.75);
}

.challenge-list { display: grid; gap: 10px; }

.room-card {
  border-radius: 14px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(2, 6, 23, 0.36);
}

.room-header,
.room-meta,
.room-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.room-meta,
.room-rules {
  margin-top: 6px;
  color: rgba(226, 232, 240, 0.78);
  font-size: 0.92rem;
}

.room-actions { margin-top: 10px; }

.mode-badge,
.status-badge,
.section-badge {
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.mode-badge.friendly { background: rgba(56, 189, 248, 0.18); color: #7dd3fc; }
.mode-badge.real { background: rgba(239, 68, 68, 0.18); color: #fca5a5; }
.status-badge.open { background: rgba(16, 185, 129, 0.2); color: #86efac; }
.status-badge.full { background: rgba(245, 158, 11, 0.2); color: #fcd34d; }

.create-modal {
  max-width: 860px;
  width: min(860px, calc(100vw - 20px));
}

.create-kind-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.kind-tab {
  flex: 1 1;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
  padding: 8px;
}

.kind-tab.active {
  background: linear-gradient(140deg, rgba(139, 92, 246, 0.36), rgba(99, 102, 241, 0.2));
  border-color: rgba(167, 139, 250, 0.8);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.rules-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.rule-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 900px) {
  .whot-lobby-content {
    width: 100%;
    max-width: 100%;
  }

  .stats-cards,
  .quick-actions-grid,
  .challenges-grid,
  .challenge-stats,
  .create-cards,
  .form-grid,
  .rules-grid {
    grid-template-columns: 1fr;
  }

  .whot-lobby-container {
    padding: 12px;
  }

  .whot-create-modal .modal-body {
    grid-template-columns: 1fr;
  }

  .whot-lobby-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .filters-bar {
    display: grid;
    grid-template-columns: 1fr;
  }
}

/* Bright text overrides for redesigned lobby */
.whot-lobby-container .form-input,
.whot-lobby-container .form-select,
.whot-lobby-container .code-input,
.whot-lobby-container .filter-select,
.whot-lobby-container .search-input,
.whot-lobby-container .join-input,
.whot-lobby-container .join-btn,
.whot-lobby-container .rules-value,
.whot-lobby-container .challenge-host,
.whot-lobby-container .challenge-rules,
.whot-lobby-container .form-hint,
.whot-lobby-container .code-hint,
.whot-lobby-container .empty-desc {
  color: #f8fafc;
}

.whot-lobby-container .form-input::placeholder,
.whot-lobby-container .code-input::placeholder,
.whot-lobby-container .search-input::placeholder {
  color: rgba(226, 232, 240, 0.85);
}

.whot-lobby-room-head {
  padding-bottom: 4px;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.15);
}

.whot-lobby-mode-badge {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.whot-lobby-mode-badge.is-real {
  color: #fecaca;
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.5);
}

.whot-lobby-mode-badge.is-friendly {
  color: #bbf7d0;
  background: rgba(34, 197, 94, 0.2);
  border: 1px solid rgba(34, 197, 94, 0.45);
}

.whot-lobby-room-actions .whot-btn {
  min-width: 88px;
}

.whot-create-choice {
  border: none;
  color: #ffffff;
}

.whot-create-choice--bot {
  background: linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%);
}

.whot-create-choice--friendly {
  background: linear-gradient(135deg, #10b981 0%, #0f766e 100%);
}

.whot-create-choice--real {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.whot-create-choice:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);
}

.whot-create-choice:disabled {
  opacity: 0.55;
}

.whot-lobby-modal {
  background: linear-gradient(165deg, #0f172a 0%, #111827 55%, #0b1220 100%);
  border: 1px solid rgba(148, 163, 184, 0.28);
  box-shadow: 0 28px 70px rgba(2, 6, 23, 0.75);
  color: #e5e7eb;
}

.whot-lobby-modal .modal-header {
  background: linear-gradient(120deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.22);
}

.whot-lobby-modal .modal-body {
  display: grid;
  gap: 10px;
}

.whot-lobby-modal .modal-header h3 {
  margin: 0;
  color: #f8fafc;
}

.whot-lobby-modal .close-btn {
  color: #cbd5e1;
}

.whot-lobby-modal .close-btn:hover {
  background: rgba(148, 163, 184, 0.18);
  color: #f8fafc;
}

.whot-lobby-modal .modal-footer {
  background: rgba(15, 23, 42, 0.82);
  border-top: 1px solid rgba(148, 163, 184, 0.22);
}

.whot-lobby-modal .whot-modal-create-btn {
  order: 1;
  flex: 2 1;
  min-height: 44px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-weight: 800;
  cursor: pointer;
}

.whot-lobby-modal .whot-modal-create-btn:hover:not(:disabled) {
  box-shadow: 0 10px 22px rgba(34, 197, 94, 0.28);
}

.whot-lobby-modal .whot-modal-create-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.whot-lobby-modal .whot-modal-cancel-btn {
  order: 2;
  flex: 1 1;
  min-height: 44px;
  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
}

.whot-lobby-modal .whot-modal-cancel-btn:hover {
  box-shadow: 0 8px 18px rgba(239, 68, 68, 0.25);
}

.whot-lobby-modal .form-group {
  margin-bottom: 14px;
}

.whot-lobby-modal .whot-wager-group {
  border: 1px solid rgba(250, 204, 21, 0.45);
  background: rgba(250, 204, 21, 0.1);
  border-radius: 12px;
  padding: 10px;
}

.whot-lobby-modal .whot-wager-group .form-label {
  color: #fde68a;
}

.whot-lobby-modal .whot-wager-input {
  border: 1px solid rgba(250, 204, 21, 0.7) !important;
  background: rgba(15, 23, 42, 0.9) !important;
  background-color: rgba(15, 23, 42, 0.9) !important;
  color: #f8fafc !important;
  -webkit-text-fill-color: #f8fafc !important;
  caret-color: #f8fafc !important;
  font-weight: 700;
  font-size: 1.02rem;
  opacity: 1 !important;
  box-shadow: none !important;
  appearance: textfield;
  -moz-appearance: textfield;
  color-scheme: dark;
}

.whot-lobby-modal .whot-wager-input::placeholder {
  color: rgba(254, 240, 138, 0.9);
}

.whot-lobby-modal input[type="number"].whot-wager-input::-webkit-outer-spin-button,
.whot-lobby-modal input[type="number"].whot-wager-input::-webkit-inner-spin-button {
  opacity: 1;
}

.whot-lobby-modal .whot-wager-input:-webkit-autofill,
.whot-lobby-modal .whot-wager-input:-webkit-autofill:hover,
.whot-lobby-modal .whot-wager-input:-webkit-autofill:focus {
  -webkit-text-fill-color: #f8fafc !important;
  box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.9) inset !important;
  background-color: rgba(15, 23, 42, 0.9) !important;
}

.whot-lobby-modal .form-group > label {
  color: #e2e8f0;
  font-weight: 700;
}

.whot-lobby-modal .whot-input {
  background: rgba(15, 23, 42, 0.9) !important;
  border: 1px solid rgba(148, 163, 184, 0.45);
  color: #f8fafc !important;
}

.whot-lobby-modal .whot-input:focus {
  border-color: rgba(96, 165, 250, 0.85);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
}

.whot-lobby-modal .whot-input::placeholder {
  color: rgba(203, 213, 225, 0.85);
}

.whot-lobby-modal select.whot-input option {
  background: #0f172a;
  color: #f8fafc;
}

.whot-lobby-modal .whot-input:disabled {
  background: rgba(30, 41, 59, 0.9) !important;
  color: #94a3b8 !important;
  opacity: 1;
}

/* Keep friend datalist input readable across browser default/autofill styling. */
.whot-lobby-modal .whot-input[list] {
  background: rgba(15, 23, 42, 0.9) !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.55);
}

.whot-lobby-modal .whot-input[list]::placeholder {
  color: rgba(203, 213, 225, 0.85);
}

.whot-lobby-modal .whot-input[list]:disabled {
  background: rgba(30, 41, 59, 0.9) !important;
  color: #94a3b8 !important;
  opacity: 1;
}

.whot-lobby-modal .whot-input[list]:-webkit-autofill,
.whot-lobby-modal .whot-input[list]:-webkit-autofill:hover,
.whot-lobby-modal .whot-input[list]:-webkit-autofill:focus {
  -webkit-text-fill-color: #f8fafc;
  box-shadow: 0 0 0 1000px #0f172a inset;
}

.whot-lobby-modal small {
  color: #94a3b8;
}

.whot-house-rules-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.whot-house-rule-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.45);
  color: #f8fafc;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.whot-house-rule-item input {
  accent-color: #38bdf8;
}

.whot-lobby-alert {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(127, 29, 29, 0.35);
  border: 1px solid rgba(248, 113, 113, 0.55);
  color: #fee2e2;
  font-weight: 600;
}

.whot-lobby-alert--modal {
  margin-bottom: 6px;
  background: rgba(127, 29, 29, 0.45);
}

@media (max-width: 768px) {
  .whot-page--lobby {
    padding: 8px;
  }

  .whot-page--lobby .whot-shell {
    max-width: 100%;
  }

  .whot-page--lobby .whot-header {
    margin-bottom: 12px;
  }

  .whot-page--lobby .whot-title {
    font-size: 22px;
  }

  .whot-page--lobby .whot-card {
    padding: 10px;
    border-radius: 12px;
  }

  .whot-page--lobby .whot-lobby-room {
    padding: 10px !important;
  }

  .whot-lobby-create-actions .whot-btn {
    flex: 1 1 100%;
  }

  .whot-lobby-quick-row .whot-input {
    min-width: 100%;
  }

  .whot-house-rules-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.whot-turn-alert {
  margin: 10px 0 12px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(15, 23, 42, 0.35);
  color: rgba(241, 245, 249, 0.95);
  font-weight: 700;
  text-align: center;
}

.whot-turn-alert.is-active {
  border-color: rgba(34, 197, 94, 0.75);
  background: rgba(22, 163, 74, 0.2);
  animation: whotTurnPulse 1.1s ease-in-out infinite;
}

.cm-start-spotlight--whot {
  gap: 8px;
  margin: 10px auto 8px;
  padding: 10px 14px;
  max-width: 320px;
  border-radius: 14px;
  background:
    radial-gradient(circle at top, rgba(251, 191, 36, 0.12), transparent 56%),
    rgba(15, 23, 42, 0.72);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);
}

.cm-start-spotlight--whot .cm-start-spotlight__title {
  font-size: 0.82rem;
}

.cm-start-spotlight--whot .cm-start-spotlight__sub {
  font-size: 0.72rem;
  line-height: 1.35;
}

.cm-start-spotlight--whot .cm-btn--start-compact {
  min-width: 0;
  padding: 9px 16px;
  font-size: 0.82rem;
  font-weight: 800;
  border-radius: 999px;
  box-shadow: 0 8px 18px rgba(251, 191, 36, 0.18);
}

.whot-opponent-panel--active {
  /* Removed large box yellow border */
}

.whot-opponent-panel--active .whot-opponent-head strong {
  color: #facc15;
  text-shadow: 0 0 8px rgba(250, 204, 21, 0.6);
}

.whot-opponent-panel--active .whot-opponent-fan {
  filter: drop-shadow(0 -4px 8px rgba(250, 204, 21, 0.4));
}

.whot-hand--active-turn {
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.7);
}

.whot-hand-card {
  transition: transform 120ms ease, opacity 120ms ease;
  position: relative;
}

.whot-hand-card:hover,
.whot-hand-card:focus-within {
  z-index: 10;
}

.whot-hand-card--dragging {
  opacity: 0.65;
  transform: translateY(-8px);
}

@keyframes whotTurnPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
}

@media (max-width: 600px) {
  .cm-start-spotlight--whot {
    margin: 8px auto 6px;
    padding: 9px 12px;
    max-width: calc(100% - 20px);
  }

  .cm-start-spotlight--whot .cm-btn--start-compact {
    width: auto;
    padding: 8px 14px;
    font-size: 0.78rem;
  }
}

/* Weekly Leaderboard Styles */
.weekly-leaderboard {
  background: rgba(30, 41, 59, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.weekly-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.weekly-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  color: #facc15;
}

.refresh-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  transition: transform 0.3s;
}

.refresh-btn:hover {
  transform: rotate(180deg);
}

.weekly-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.weekly-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  transition: all 0.2s;
}

.weekly-item:hover {
  background: rgba(255, 255, 255, 0.07);
}

.weekly-rank {
  font-weight: 800;
  width: 24px;
  text-align: center;
}

.weekly-player {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.player-name {
  font-weight: 600;
  font-size: 0.95rem;
}

.player-wins {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
}

.weekly-points {
  font-weight: 700;
  color: #10b981;
}

.weekly-points small {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.4);
}

.weekly-footer {
  margin-top: 16px;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.3);
  text-align: center;
}

.weekly-loader, .weekly-error {
  text-align: center;
  padding: 20px;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.5);
}

.rank-1 { border-left: 3px solid #facc15; background: rgba(250, 204, 21, 0.05); }
.rank-2 { border-left: 3px solid #cbd5e1; background: rgba(203, 213, 225, 0.05); }
.rank-3 { border-left: 3px solid #d97706; background: rgba(217, 119, 6, 0.05); }


/* Weekly Leaderboard Modal & Trigger */
.leaderboard-trigger {
  background: rgba(250, 204, 21, 0.15);
  border: 1px solid rgba(250, 204, 21, 0.4);
  color: #facc15;
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.leaderboard-trigger:hover {
  background: rgba(250, 204, 21, 0.25);
  transform: translateY(-1px);
}

.leaderboard-modal {
  max-width: 500px;
}

.weekly-leaderboard-content {
  padding: 8px 4px;
}

.weekly-score-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  background: rgba(16, 185, 129, 0.1);
  padding: 6px;
  border-radius: 10px;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.score-value {
  font-size: 1.2rem;
  font-weight: 900;
  color: #10b981;
  line-height: 1;
}

.score-label {
  font-size: 0.65rem;
  font-weight: 800;
  color: rgba(16, 185, 129, 0.8);
  margin-top: 2px;
}

.player-points-detail {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 2px;
}

.grid-full {
  width: 100%;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .section-header {
    flex-direction: column;
    gap: 12px;
  }
  
  .leaderboard-trigger {
    width: 100%;
    justify-content: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Whot.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,kDAAkD;EAClD,sDAAsD;EACtD,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,6DAA6D;EAC7D,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb;;;2FAGyF;AAC3F;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;AAEA;EACE;;;uEAGqE;EACrE,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,kFAAkF;EAClF,YAAY;AACd;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gEAAgE;EAChE,YAAY;AACd;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mHAAmH;IACnH,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA,oCAAoC;AACpC,yCAAyC;AACzC,oCAAoC;AACpC;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,6DAA6D;EAC7D,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8CAA8C,QAAQ,EAAE,SAAS,EAAE,uBAAuB,EAAE,8BAA8B,EAAE;AAC5H,8CAA8C,QAAQ,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC3F,8CAA8C,WAAW,EAAE,SAAS,EAAE,yBAAyB,EAAE,uBAAuB,EAAE;AAC1H,8CAA8C,WAAW,EAAE,UAAU,EAAE,yBAAyB,EAAE,uBAAuB,EAAE,8BAA8B,EAAE;;AAE3J,0EAA0E;AAC1E;;;;;EAKE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,6DAA6D;EAC7D,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;EAC7C,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;EAUE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC,sCAAsC;AACtC,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gDAAgD,QAAQ,EAAE,SAAS,EAAE;AACrE,gDAAgD,QAAQ,EAAE,UAAU,EAAE;AACtE,gDAAgD,WAAW,EAAE,SAAS,EAAE,yBAAyB,EAAE;AACnG,gDAAgD,WAAW,EAAE,UAAU,EAAE,yBAAyB,EAAE;;AAEpG;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW,yCAAyC,EAAE;EACtD,MAAM,2CAA2C,EAAE;AACrD;;AAEA,kCAAkC;AAClC;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,qDAAqD;AACvD;;AAEA,+CAA+C,QAAQ,EAAE,SAAS,EAAE,uBAAuB,EAAE;AAC7F,gDAAgD,QAAQ,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC7F,kDAAkD,WAAW,EAAE,SAAS,EAAE,uBAAuB,EAAE,yBAAyB,EAAE;AAC9H,mDAAmD,WAAW,EAAE,UAAU,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;;AAE9H;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sDAAsD,iBAAiB,EAAE;;AAEzE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oDAAoD,kBAAkB,EAAE;;AAExE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA,qDAAqD,iBAAiB,EAAE;;AAExE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,2DAA2D,kBAAkB,EAAE;;AAE/E,qCAAqC;AACrC;EACE,+CAA+C;EAC/C,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qDAAqD;EACrD,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,SAAS;AACX;;AAEA,6DAA6D;AAC7D;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,uCAAuC;EACvC,qDAAqD;EACrD,UAAU;AACZ;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,4CAA4C;EAC5C,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yHAAyH;AAC3H;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,iBAAiB;EACjB,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,yHAAyH;AAC3H;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE,OAAO,iCAAiC,EAAE;EAC1C,KAAK,iCAAiC,EAAE;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,0EAA0E;EAC1E,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gCAAgC;EAChC,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA,8CAA8C,QAAQ,EAAE,SAAS,EAAE;EACnE,8CAA8C,WAAW,EAAE,UAAU,EAAE;;EAEvE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;IAKE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;;;;;IAUE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA,sDAAsD;;EAEtD;IACE,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,kCAAkC;IAClC,QAAQ;IACR,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE;MACE,gBAAgB;MAChB,SAAS;MACT,OAAO;MACP,QAAQ;MACR,WAAW;MACX,+BAA+B;MAC/B,gBAAgB;MAChB,0CAA0C;MAC1C,mDAAmD;MACnD,gBAAgB;IAClB;IACA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;IAGE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;IAKE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;;;;;IAUE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;EAC3C,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;EAC3C,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE,mFAAmF;AACrF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb;;6CAE2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW,wCAAwC,EAAE;EACrD,MAAM,kDAAkD,EAAE;AAC5D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;;;EAKE,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,cAAc,gCAAgC,EAAE,eAAe,EAAE;AACjE,cAAc,gBAAgB,EAAE,iBAAiB,EAAE;;AAEnD;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA,sBAAsB,gDAAgD,EAAE;AACxE,mBAAmB,gDAAgD,EAAE;;AAErE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,2BAA2B,uFAAuF,EAAE;AACpH,4BAA4B,qFAAqF,EAAE;;AAEnH,aAAa,aAAa,EAAE,QAAQ,EAAE;AACtC,cAAc,WAAW,EAAE;AAC3B,YAAY,WAAW,EAAE;;AAEzB;;;;;EAKE,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;EAChC,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA,iFAAiF;AACjF;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,qCAAqC;EACrC,eAAe;AACjB;;AAEA,mBAAmB,qDAAqD,EAAE;AAC1E,oBAAoB,qDAAqD,EAAE;AAC3E,qBAAqB,qDAAqD,EAAE;;AAE5E;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,qDAAqD;EACrD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA,kBAAkB,aAAa,EAAE,SAAS,EAAE;;AAE5C;EACE,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,gBAAgB,gBAAgB,EAAE;;AAElC;;;EAGE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,uBAAuB,oCAAoC,EAAE,cAAc,EAAE;AAC7E,mBAAmB,mCAAmC,EAAE,cAAc,EAAE;AACxE,qBAAqB,mCAAmC,EAAE,cAAc,EAAE;AAC1E,qBAAqB,mCAAmC,EAAE,cAAc,EAAE;;AAE1E;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sFAAsF;EACtF,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;;;;;IAOE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;AACF;;AAEA,+CAA+C;AAC/C;;;;;;;;;;;;;EAaE,cAAc;AAChB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0EAA0E;EAC1E,2CAA2C;EAC3C,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,2FAA2F;EAC3F,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;EAC5C,kDAAkD;EAClD,yBAAyB;EACzB,2CAA2C;EAC3C,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;EAGE,2CAA2C;EAE3C,+DAA+D;EAC/D,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,UAAU;AACZ;;AAEA,iFAAiF;AACjF;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;EAGE,gCAAgC;EAEhC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB;;0BAEwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,8BAA8B;AAC9B;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,UAAU,8BAA8B,EAAE,oCAAoC,EAAE;AAChF,UAAU,8BAA8B,EAAE,qCAAqC,EAAE;AACjF,UAAU,8BAA8B,EAAE,mCAAmC,EAAE;;;AAG/E,uCAAuC;AACvC;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --whot-primary: #8b5cf6;\n  --whot-primary-dark: #7c3aed;\n  --whot-secondary: #10b981;\n  --whot-danger: #ef4444;\n  --whot-warning: #f59e0b;\n  --whot-dark: #0f172a;\n  --whot-dark-light: #1e293b;\n  --whot-light: #f8fafc;\n  --whot-gray: #64748b;\n  --whot-gray-light: #cbd5e1;\n  --whot-radius: 16px;\n  --whot-radius-sm: 10px;\n  --whot-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3);\n  --whot-shadow-lg: 0 25px 50px -12px rgba(0, 0, 0, 0.4);\n  --whot-transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.whot-page {\n  min-height: 100vh;\n  padding: 20px;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  color: var(--whot-light);\n}\n\n.whot-shell {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.whot-header {\n\n/* Room page: more traditional table look (mobile-friendly) */\n.whot-page--room {\n  padding: 12px;\n  background:\n    radial-gradient(1200px 520px at 50% 40%, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.70)),\n    repeating-linear-gradient(90deg, #7b4a2b 0 18px, #6f4328 18px 36px),\n    repeating-linear-gradient(0deg, rgba(255,255,255,0.05) 0 2px, rgba(0,0,0,0.06) 2px 4px);\n}\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.whot-title {\n\n.whot-page--room .whot-table {\n  background:\n    radial-gradient(900px 520px at 50% 30%, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0)),\n    linear-gradient(180deg, rgba(0,0,0,0.18), rgba(0,0,0,0.30)),\n    repeating-linear-gradient(90deg, #7b4a2b 0 20px, #6b4026 20px 40px);\n  border-radius: 24px;\n  padding: 14px;\n  min-height: 0;\n}\n  font-size: 28px;\n  margin: 0;\n}\n\n.whot-subtitle {\n  margin-top: 6px;\n  color: rgba(248, 250, 252, 0.75);\n}\n\n.whot-table-center-label {\n  min-width: 140px;\n  text-align: center;\n}\n\n.whot-table-turn {\n  font-weight: 900;\n  font-size: 1.35rem;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.55);\n}\n\n.whot-card {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: var(--whot-radius);\n  box-shadow: var(--whot-shadow);\n  padding: 6px 2px;\n}\n\n.whot-opponents-row {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 4px;\n  min-height: 65px;\n  max-width: 100%;\n}\n\n.whot-table-toprow {\n  margin-bottom: 10px;\n}\n\n.whot-opponent-panel {\n  margin-top: -15px;\n  margin-inline: 4px;\n  padding: 0;\n  background: none;\n  box-shadow: none;\n  width: 110px;\n}\n\n\n.whot-opponent-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.whot-opponent-fan {\n  position: relative;\n  height: 80px;\n  width: 130px;\n}\n\n.whot-opponent-fan-card {\n  position: absolute;\n  top: 0;\n  transform-origin: bottom center;\n}\n\n.whot-opponent-fan .whot-playing-card {\n  cursor: default;\n  transform: scale(0.5);\n}\n\n.whot-opponent-fan .whot-playing-card:hover {\n  transform: scale(0.5);\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.20);\n}\n\n@media (max-width: 480px) {\n  .whot-page--room {\n    padding: 2px;\n  }\n\n  .whot-page--room .whot-table {\n    padding: 4px;\n  }\n\n  .whot-opponents-row {\n    gap: 26px;\n    margin-bottom: 0px;\n    min-height: 65px;\n    flex-wrap: wrap;\n    justify-content: center;\n    overflow: hidden;\n  }\n\n  .whot-opponent-fan {\n    height: 80px;\n    width: 100px;\n  }\n\n  .whot-playing-card {\n    width: 20px;\n    height: 105px;\n  }\n\n  .whot-card--in-table {\n    padding: 2px 1px;\n  }\n}\n.whot-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (min-width: 980px) {\n  .whot-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (orientation: portrait) and (max-width: 768px) {\n  .whot-table {\n    min-height: 40vh;\n  }\n  .whot-opponents-row {\n    padding-left: 10px;\n  }\n}\n\n.whot-btn {\n  padding: 0.75rem 1.2rem;\n  border: none;\n  border-radius: 999px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: var(--whot-transition);\n  color: white;\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n}\n\n.whot-btn:hover {\n  transform: translateY(-1px);\n  background: rgba(255, 255, 255, 0.13);\n}\n\n.whot-btn-primary {\n  background: linear-gradient(135deg, var(--whot-primary), var(--whot-primary-dark));\n  border: none;\n}\n\n.whot-btn-primary:hover {\n  box-shadow: 0 8px 20px rgba(139, 92, 246, 0.25);\n}\n\n.whot-btn-danger {\n  background: linear-gradient(135deg, var(--whot-danger), #dc2626);\n  border: none;\n}\n\n.whot-btn-danger:hover {\n  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.22);\n}\n\n.whot-btn-warning {\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  border: none;\n  color: #fff;\n}\n\n.whot-btn-warning:hover {\n  box-shadow: 0 8px 20px rgba(245, 158, 11, 0.3);\n}\n\n/* Pick Two / Pick Three penalty banner */\n.whot-pick-banner {\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.whot-pick-banner--danger {\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid #ef4444;\n  color: #fca5a5;\n}\n\n/* Drawn-card hint (play it or pass) */\n.whot-drawn-card-hint {\n  padding: 4px 12px;\n  background: rgba(245, 158, 11, 0.15);\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  color: #fde68a;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.whot-input {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: white;\n  outline: none;\n}\n\n.whot-label {\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.7);\n  margin-bottom: 6px;\n}\n\n.whot-row {\n  display: grid;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.whot-hand {\n  overflow-x: auto;\n  overflow-y: hidden;\n  flex-wrap: nowrap !important;\n  justify-content: flex-start !important;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 6px !important;\n}\n\n.whot-hand-card {\n  flex: 0 0 auto;\n  scroll-snap-align: center;\n}\n\n.whot-hand::-webkit-scrollbar {\n  height: 6px;\n}\n\n.whot-hand::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n}\n\n.whot-hand::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.35);\n  border-radius: 999px;\n}\n\n.whot-copy-icon {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n@media (max-width: 900px) and (orientation: landscape) {\n  .whot-page--room {\n    padding: 6px;\n  }\n\n  .whot-shell {\n    max-width: 100%;\n  }\n\n  .whot-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n    margin-bottom: 10px;\n  }\n\n  .whot-title {\n    font-size: 20px;\n  }\n\n  .whot-room-title {\n    display: none;\n  }\n\n  .whot-subtitle {\n    font-size: 0.9rem;\n  }\n\n  .whot-page--room .whot-table {\n    padding: 8px;\n    border-radius: 16px;\n  }\n\n  .whot-opponents-row {\n    gap: 4px;\n    margin-bottom: 2px;\n    min-height: 55px;\n  }\n\n  .whot-opponent-panel {\n    width: 90px;\n  }\n\n  .whot-opponent-fan {\n    height: 65px;\n    width: 90px;\n  }\n\n  .whot-playing-card.is-small {\n    width: 58px;\n    height: 88px;\n  }\n\n  .whot-table-center {\n    gap: 8px;\n  }\n\n  .whot-turn-indicator {\n    font-size: 0.95rem;\n    padding: 6px 10px;\n  }\n\n  .whot-room-id {\n    font-size: 0.8rem;\n    opacity: 0.7;\n    max-width: 70vw;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .whot-copy-btn {\n    padding: 0.35rem 0.6rem;\n    min-width: 36px;\n    min-height: 32px;\n  }\n\n  .whot-copy-icon {\n    width: 16px;\n    height: 16px;\n    display: block;\n  }\n\n  .whot-controls {\n    position: sticky;\n    bottom: 0;\n    z-index: 5;\n    background: linear-gradient(180deg, rgba(15, 23, 42, 0) 0%, rgba(15, 23, 42, 0.8) 40%, rgba(15, 23, 42, 0.95) 100%);\n    padding: 6px 0 10px;\n  }\n}\n\n.whot-playing-card {\n  width: 100px;\n  height: 140px;\n  border-radius: 10px;\n  background: var(--whot-card-bg, #f3f4f6);\n  color: #111827;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.20);\n  transition: var(--whot-transition);\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  isolation: isolate;\n}\n\n.whot-playing-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.28);\n}\n\n.whot-playing-card.selected {\n  transform: translateY(-18px);\n  box-shadow: 0 0 0 3px var(--whot-card-color, var(--whot-primary));\n}\n\n.whot-playing-card.is-small {\n  width: 70px;\n  height: 105px;\n}\n\n/* =============================== */\n/* Photo/traditional Whot face (scoped) */\n/* =============================== */\n.whot-playing-card--photo {\n  background: #ffffff;\n  border: 1.5px solid #c7ceda;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);\n}\n\n.whot-playing-card--photo::before {\n  content: '';\n  position: absolute;\n  inset: 6px;\n  border-radius: 8px;\n  border: 1px solid rgba(30, 41, 59, 0.18);\n  pointer-events: none;\n}\n\n.whot-playing-card--photo {\n  --whot-ink-red: var(--whot-card-color, #9B0F0F);\n}\n\n.whot-playing-card--photo .photo-corner {\n  position: absolute;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  color: var(--whot-ink-red);\n  font-family: 'Arial Black', 'Segoe UI', system-ui, sans-serif;\n  font-weight: 900;\n  line-height: 1;\n  z-index: 3;\n}\n\n.whot-playing-card--photo .photo-corner-number {\n  font-size: 1.6rem;\n  letter-spacing: -0.02em;\n}\n\n.whot-playing-card--photo.is-small .photo-corner-number {\n  font-size: 1.1rem;\n}\n\n.whot-playing-card--photo .photo-corner-symbol {\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n}\n\n.whot-playing-card--photo.is-small .photo-corner-symbol {\n  width: 12px;\n  height: 12px;\n}\n\n.whot-playing-card--photo .photo-corner-w {\n  font-family: Georgia, 'Times New Roman', Times, serif;\n  font-weight: 900;\n  font-style: italic;\n  font-size: 1.1rem;\n  transform: translateY(1px);\n}\n\n.whot-playing-card--photo.is-small .photo-corner-w {\n  font-size: 0.85rem;\n}\n\n.whot-playing-card--photo .photo-corner--tl { top: 8px; left: 8px; align-items: flex-start; flex-direction: column-reverse; }\n.whot-playing-card--photo .photo-corner--tr { top: 8px; right: 8px; align-items: flex-end; }\n.whot-playing-card--photo .photo-corner--bl { bottom: 8px; left: 8px; transform: rotate(180deg); align-items: flex-start; }\n.whot-playing-card--photo .photo-corner--br { bottom: 8px; right: 8px; transform: rotate(180deg); align-items: flex-start; flex-direction: column-reverse; }\n\n/* Circle 10–14: the bottom-right small circle can crowd the center mark */\n.whot-playing-card--photo.shape-circle[data-number=\"10\"] .photo-corner--br,\n.whot-playing-card--photo.shape-circle[data-number=\"11\"] .photo-corner--br,\n.whot-playing-card--photo.shape-circle[data-number=\"12\"] .photo-corner--br,\n.whot-playing-card--photo.shape-circle[data-number=\"13\"] .photo-corner--br,\n.whot-playing-card--photo.shape-circle[data-number=\"14\"] .photo-corner--br {\n  gap: 0px;\n}\n\n.whot-playing-card--photo .photo-center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.whot-playing-card--photo .photo-center-symbol {\n  width: 82px;\n  height: 82px;\n  display: inline-flex;\n}\n\n.whot-playing-card--photo .photo-center-number {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-family: 'Arial Black', 'Segoe UI', system-ui, sans-serif;\n  font-weight: 900;\n  font-size: 1.8rem;\n  letter-spacing: -0.04em;\n  color: #ffffff;\n  text-shadow: 0 2px 6px rgba(15, 23, 42, 0.45);\n  line-height: 1;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.whot-playing-card--photo.is-small .photo-center-number {\n  font-size: 1.2rem;\n  letter-spacing: -0.05em;\n}\n\n/* Some high-number circle/triangle cards need a slightly smaller center mark */\n.whot-playing-card--photo.shape-circle[data-number=\"10\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-circle[data-number=\"11\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-circle[data-number=\"12\"] .photo-center-symbol {\n  width: 74px;\n  height: 74px;\n}\n\n.whot-playing-card--photo.shape-circle[data-number=\"13\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-circle[data-number=\"14\"] .photo-center-symbol {\n  width: 72px;\n  height: 72px;\n}\n\n.whot-playing-card--photo.shape-square[data-number=\"3\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-square[data-number=\"11\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-square[data-number=\"10\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-square[data-number=\"13\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-square[data-number=\"14\"] .photo-center-symbol {\n  width: 72px;\n  height: 72px;\n}\n\n.whot-playing-card--photo.shape-triangle[data-number=\"3\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"4\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"5\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"7\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"8\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"10\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"11\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"12\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"13\"] .photo-center-symbol,\n.whot-playing-card--photo.shape-triangle[data-number=\"14\"] .photo-center-symbol {\n  width: 72px;\n  height: 72px;\n}\n\n.whot-playing-card--photo.is-small.shape-circle[data-number=\"10\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-circle[data-number=\"11\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-circle[data-number=\"12\"] .photo-center-symbol {\n  width: 54px;\n  height: 54px;\n}\n\n.whot-playing-card--photo.is-small.shape-circle[data-number=\"13\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-circle[data-number=\"14\"] .photo-center-symbol {\n  width: 52px;\n  height: 52px;\n}\n\n.whot-playing-card--photo.is-small.shape-square[data-number=\"3\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-square[data-number=\"11\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-square[data-number=\"10\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-square[data-number=\"13\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-square[data-number=\"14\"] .photo-center-symbol {\n  width: 52px;\n  height: 52px;\n}\n\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"3\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"4\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"5\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"7\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"8\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"10\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"11\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"12\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"13\"] .photo-center-symbol,\n.whot-playing-card--photo.is-small.shape-triangle[data-number=\"14\"] .photo-center-symbol {\n  width: 52px;\n  height: 52px;\n}\n\n.whot-playing-card--photo.is-small .photo-center-symbol {\n  width: 60px;\n  height: 60px;\n}\n\n.whot-playing-card--photo .photo-whot {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  color: var(--whot-ink-red);\n}\n\n.whot-playing-card--photo .photo-whot-text {\n  font-family: Georgia, 'Times New Roman', Times, serif;\n  font-size: 1.65rem;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n}\n\n.whot-playing-card--photo.is-small .photo-whot-text {\n  font-size: 1.2rem;\n}\n\n.whot-playing-card--photo .photo-whot-w {\n  font-family: Georgia, 'Times New Roman', Times, serif;\n  font-style: italic;\n  font-weight: 900;\n  font-size: 1.15rem;\n  line-height: 1;\n}\n\n.whot-playing-card--photo .photo-whot-w--flip {\n  transform: rotate(180deg);\n}\n\n.whot-playing-card--photo.is-small .photo-whot-w {\n  font-size: 0.9rem;\n}\n\n/* =============================== */\n/* example.html card design (scoped) */\n/* =============================== */\n.whot-playing-card--example {\n  background: #ffffff;\n  border: 2px solid #1e293b;\n}\n\n.whot-playing-card--example .corner-number {\n  position: absolute;\n  font-size: 1.8rem;\n  font-weight: 900;\n  color: #1e293b;\n  font-family: 'Arial Black', 'Segoe UI', sans-serif;\n}\n\n.whot-playing-card--example.is-small .corner-number {\n  font-size: 1.2rem;\n}\n\n.whot-playing-card--example .corner-number.tl { top: 8px; left: 8px; }\n.whot-playing-card--example .corner-number.tr { top: 8px; right: 8px; }\n.whot-playing-card--example .corner-number.bl { bottom: 8px; left: 8px; transform: rotate(180deg); }\n.whot-playing-card--example .corner-number.br { bottom: 8px; right: 8px; transform: rotate(180deg); }\n\n.whot-playing-card--example .card-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n  height: 80%;\n}\n\n.whot-playing-card--example:not(.is-whot) .shape-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.whot-playing-card--example:not(.is-whot) .shape-symbol {\n  font-size: 4.5rem;\n  position: absolute;\n  color: var(--shape-color, #1e293b);\n  opacity: 0.9;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n.whot-playing-card--example.is-small:not(.is-whot) .shape-symbol {\n  font-size: 3rem;\n}\n\n.whot-playing-card--example:not(.is-whot) .center-number {\n  position: absolute;\n  font-size: 2.2rem;\n  font-weight: 900;\n  color: white;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  z-index: 2;\n  font-family: 'Arial Black', 'Segoe UI', sans-serif;\n}\n\n.whot-playing-card--example.is-small:not(.is-whot) .center-number {\n  font-size: 1.5rem;\n}\n\n/* WHOT (20) */\n.whot-playing-card--example.is-whot {\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  border-color: #d97706;\n}\n\n.whot-playing-card--example.is-whot .corner-number {\n  color: #92400e;\n}\n\n.whot-playing-card--example.is-whot .whot-star {\n  font-size: 4.5rem;\n  color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);\n  animation: whot-pulse 2s infinite;\n}\n\n.whot-playing-card--example.is-small.is-whot .whot-star {\n  font-size: 3rem;\n}\n\n.whot-playing-card--example.is-whot .whot-text {\n  position: absolute;\n  top: calc(50% + 25px);\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 1.4rem;\n  font-weight: 900;\n  color: white;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  letter-spacing: 1px;\n  background: rgba(146, 64, 14, 0.8);\n  padding: 4px 12px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.whot-playing-card--example.is-small.is-whot .whot-text {\n  font-size: 1rem;\n  top: calc(50% + 18px);\n  padding: 3px 8px;\n}\n\n@keyframes whot-pulse {\n  0%, 100% { transform: translate(-50%, -50%) scale(1); }\n  50% { transform: translate(-50%, -50%) scale(1.1); }\n}\n\n/* Classic (pre-photo) card face */\n.whot-playing-card--classic {\n  background: var(--whot-card-bg, #f3f4f6);\n  border: 2px solid #0b1220;\n}\n\n.whot-playing-card--classic::before {\n  content: '';\n  position: absolute;\n  inset: 5px;\n  border-radius: 7px;\n  border: 1px solid rgba(17, 24, 39, 0.22);\n  pointer-events: none;\n}\n\n.whot-playing-card--classic .corner {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  z-index: 2;\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n}\n\n.whot-playing-card--classic .corner-top-left { top: 8px; left: 8px; align-items: flex-start; }\n.whot-playing-card--classic .corner-top-right { top: 8px; right: 8px; align-items: flex-end; }\n.whot-playing-card--classic .corner-bottom-left { bottom: 8px; left: 8px; align-items: flex-start; transform: rotate(180deg); }\n.whot-playing-card--classic .corner-bottom-right { bottom: 8px; right: 8px; align-items: flex-end; transform: rotate(180deg); }\n\n.whot-playing-card--classic .corner-number {\n  font-size: 1.75rem;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.whot-playing-card--classic.is-small .corner-number { font-size: 1.2rem; }\n\n.whot-playing-card--classic .corner-suit {\n  font-size: 1.25rem;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.whot-playing-card--classic.is-small .corner-suit { font-size: 0.95rem; }\n\n.whot-playing-card--classic .card-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n  z-index: 1;\n}\n\n.whot-playing-card--classic .shape-symbol {\n  font-size: 4rem;\n  line-height: 1;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.10);\n}\n\n.whot-playing-card--classic.is-small .shape-symbol { font-size: 2.9rem; }\n\n.whot-playing-card--classic .whot-center-number {\n  position: absolute;\n  font-size: 1.6rem;\n  font-weight: 900;\n  text-shadow: 0 2px 6px rgba(0,0,0,0.35);\n}\n\n.whot-playing-card--classic.is-small .whot-center-number { font-size: 1.25rem; }\n\n/* Traditional Nigerian Whot layout */\n.whot-playing-card--traditional {\n  --whot-ink-red: var(--whot-card-color, #9B0F0F);\n  background: var(--whot-card-bg, #f3f4f6);\n  border: 2px solid #0b1220;\n}\n\n.whot-playing-card--traditional::before {\n  content: '';\n  position: absolute;\n  inset: 5px;\n  border-radius: 7px;\n  border: 1px solid rgba(17, 24, 39, 0.22);\n  pointer-events: none;\n}\n\n.whot-playing-card--traditional .whot-corner {\n  position: absolute;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  color: var(--whot-ink-red);\n  font-weight: 900;\n  z-index: 3;\n}\n\n.whot-playing-card--traditional .whot-corner--tl {\n  top: 8px;\n  left: 8px;\n}\n\n.whot-playing-card--traditional .whot-corner--br {\n  bottom: 8px;\n  right: 8px;\n  transform: rotate(180deg);\n}\n\n.whot-playing-card--traditional .whot-corner-number {\n  font-size: 1.8rem;\n  line-height: 1;\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n  text-shadow: 0 1px 0 rgba(255,255,255,0.7);\n}\n\n.whot-playing-card--traditional.is-small .whot-corner-number {\n  font-size: 1.15rem;\n}\n\n.whot-playing-card--traditional .whot-corner-symbol {\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Triangle corner symbols are offset in the traditional deck */\n.whot-playing-card--traditional.shape-triangle .whot-corner {\n  width: 34px;\n  height: 48px;\n}\n\n.whot-playing-card--traditional.shape-triangle.is-small .whot-corner {\n  width: 28px;\n  height: 42px;\n}\n\n.whot-playing-card--traditional.shape-triangle .whot-corner-symbol {\n  position: absolute;\n}\n\n/* top-left: small triangle sits by the top angle (to the side) */\n.whot-playing-card--traditional.shape-triangle .whot-corner--tl .whot-corner-symbol {\n  right: -2px;\n  top: 22px;\n}\n\n/* bottom-right: small triangle sits closer to the baseline */\n.whot-playing-card--traditional.shape-triangle .whot-corner--br .whot-corner-symbol {\n  left: -2px;\n  top: 26px;\n}\n\n.whot-playing-card--traditional.shape-triangle.is-small .whot-corner--tl .whot-corner-symbol {\n  right: -2px;\n  top: 18px;\n}\n\n.whot-playing-card--traditional.shape-triangle.is-small .whot-corner--br .whot-corner-symbol {\n  left: -2px;\n  top: 22px;\n}\n\n.whot-playing-card--traditional .whot-corner-symbol svg {\n  display: block;\n}\n\n.whot-playing-card--traditional.is-small .whot-corner-symbol {\n  font-size: 0.95rem;\n}\n\n.whot-playing-card--traditional .whot-center-shape {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.whot-playing-card--traditional .whot-center-symbol {\n  width: 78px;\n  height: 78px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.whot-playing-card--traditional.is-small .whot-center-symbol {\n  width: 58px;\n  height: 58px;\n}\n\n.whot-playing-card--traditional.is-small .whot-center-symbol {\n  font-size: 3.6rem;\n}\n\n.whot-playing-card--traditional .whot-center-number {\n  position: absolute;\n  color: #ffffff;\n  font-weight: 900;\n  font-size: 2.1rem;\n  letter-spacing: 0.02em;\n  text-shadow: 0 2px 6px rgba(0,0,0,0.35);\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n  z-index: 2;\n}\n\n/* STAR cards: smaller doubled-number inside the star */\n.whot-playing-card--traditional.shape-star .whot-center-number {\n  font-size: 1.75rem;\n}\n\n.whot-playing-card--traditional.shape-star.is-small .whot-center-number {\n  font-size: 1.35rem;\n}\n\n.whot-playing-card--traditional.is-small .whot-center-number {\n  font-size: 1.55rem;\n}\n\n\n.whot-playing-card--traditional .whot-whot-stack {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.whot-playing-card--traditional .whot-whot-word {\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n  font-weight: 900;\n  font-size: 1.55rem;\n  letter-spacing: 0.08em;\n  color: rgba(255,255,255,0.9);\n  -webkit-text-stroke: 3px var(--whot-ink-red);\n  paint-order: stroke fill;\n  text-shadow: 0 1px 0 rgba(255,255,255,0.4);\n}\n\n.whot-playing-card--traditional .whot-whot-word--flip {\n  transform: rotate(180deg);\n}\n\n.whot-playing-card--traditional.is-small .whot-whot-word {\n  font-size: 1.15rem;\n  -webkit-text-stroke: 2.5px var(--whot-ink-red);\n}\n\n/* New card face layout (ported from example.html) */\n.whot-playing-card .corner {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif;\n}\n\n.whot-playing-card .corner-top-left {\n  top: 8px;\n  left: 8px;\n  align-items: flex-start;\n}\n\n.whot-playing-card .corner-top-right {\n  top: 8px;\n  right: 8px;\n  align-items: flex-end;\n}\n\n.whot-playing-card .corner-bottom-left {\n  bottom: 8px;\n  left: 8px;\n  align-items: flex-start;\n}\n\n.whot-playing-card .corner-bottom-right {\n  bottom: 8px;\n  right: 8px;\n  align-items: flex-end;\n}\n\n.whot-playing-card .corner-number {\n  font-size: 1.8rem;\n  font-weight: 900;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.whot-playing-card.is-small .corner-number {\n  font-size: 1.25rem;\n}\n\n.whot-playing-card .corner-suit {\n  font-size: 1.1rem;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.whot-playing-card.is-small .corner-suit {\n  font-size: 0.9rem;\n}\n\n.whot-playing-card .corner-bottom-left,\n.whot-playing-card .corner-bottom-right {\n  transform: rotate(180deg);\n}\n\n.whot-playing-card .card-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n}\n\n.whot-playing-card .shape-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n}\n\n.whot-playing-card .shape-symbol {\n  font-size: 4rem;\n  line-height: 1;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.10);\n  font-family: \"Georgia\", \"Times New Roman\", Times, serif;\n}\n\n.whot-playing-card.is-small .shape-symbol {\n  font-size: 2.7rem;\n}\n\n.whot-playing-card .whot-card-label {\n  position: absolute;\n  left: 50%;\n  bottom: 12px;\n  transform: translateX(-50%);\n  font-size: 0.62rem;\n  font-weight: 900;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.10);\n  max-width: 88%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.whot-playing-card.is-small .whot-card-label {\n  font-size: 0.52rem;\n  bottom: 10px;\n}\n\n.whot-playing-card .whot-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.whot-playing-card .whot-star {\n  font-size: 4.2rem;\n  line-height: 1;\n  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.16);\n  animation: whot-pulse 2s infinite;\n}\n\n.whot-playing-card.is-small .whot-star {\n  font-size: 2.9rem;\n}\n\n@keyframes whot-pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.07); }\n}\n\n.whot-playing-card .whot-text {\n  font-size: 1.5rem;\n  font-weight: 900;\n  letter-spacing: 2px;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.18);\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif;\n}\n\n.whot-playing-card.is-small .whot-text {\n  font-size: 1.05rem;\n  letter-spacing: 1.2px;\n}\n\n.whot-playing-card .selected-glow {\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  right: -3px;\n  bottom: -3px;\n  border: 3px solid;\n  border-radius: 12px;\n  animation: whot-glow 1.5s ease-in-out infinite alternate;\n  pointer-events: none;\n}\n\n@keyframes whot-glow {\n  from { box-shadow: 0 0 10px currentColor; }\n  to { box-shadow: 0 0 20px currentColor; }\n}\n\n.whot-playing-card .playable-indicator {\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 12px;\n  opacity: 0.10;\n  pointer-events: none;\n}\n\n/* Face-down variant for deck cards */\n.whot-playing-card.face-down {\n  background: linear-gradient(135deg, #5B0909 0%, #9B0F0F 55%, #B61414 100%);\n  border-color: rgba(255, 255, 255, 0.58);\n}\n\n.whot-playing-card.face-down:hover {\n  transform: translateY(-6px);\n}\n\n.whot-playing-card.face-down .card-back-pattern {\n  position: absolute;\n  inset: 0;\n  background: none;\n}\n\n.whot-playing-card.face-down .card-back-logo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  color: rgba(255, 255, 255, 0.92);\n  font-family: Georgia, 'Times New Roman', Times, serif;\n  font-size: 1.55rem;\n  font-weight: 900;\n  letter-spacing: 0.04em;\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n}\n\n.whot-playing-card.face-down.is-small .card-back-logo {\n  font-size: 1.05rem;\n}\n\n.whot-playing-card.face-down .back-dot {\n  display: none;\n}\n\n.whot-playing-card .whot-card-badge {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.35);\n  color: rgba(255, 255, 255, 0.95);\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-weight: 900;\n  font-size: 0.95rem;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n}\n\n.whot-playing-card.is-small .whot-card-badge {\n  font-size: 0.8rem;\n  padding: 3px 7px;\n}\n\n@media (max-width: 360px) {\n  .whot-playing-card {\n    width: 42px;\n    height: 61px;\n  }\n\n  .whot-playing-card.is-small {\n    width: 36px;\n    height: 52px;\n  }\n\n  .whot-playing-card:hover {\n    transform: translateY(-6px);\n  }\n\n  .whot-playing-card.selected {\n    transform: translateY(-10px);\n  }\n\n  .whot-table {\n    padding: 0.6rem;\n    min-height: 250px;\n  }\n\n  .whot-table-center {\n    gap: 14px;\n  }\n\n  .whot-hand {\n    gap: 4px;\n    padding: 0.4rem;\n  }\n\n  .whot-playing-card--photo::before {\n    inset: 5px;\n  }\n\n  .whot-playing-card--photo .photo-corner--tl { top: 6px; left: 6px; }\n  .whot-playing-card--photo .photo-corner--br { bottom: 6px; right: 6px; }\n\n  .whot-playing-card--photo .photo-corner-number {\n    font-size: 1.2rem;\n  }\n\n  .whot-playing-card--photo .photo-corner-symbol {\n    width: 12px;\n    height: 12px;\n  }\n\n  .whot-playing-card--photo .photo-corner-w {\n    font-size: 0.9rem;\n  }\n\n  .whot-playing-card--photo .photo-center-symbol {\n    width: 60px;\n    height: 60px;\n  }\n\n  .whot-playing-card--photo.shape-circle[data-number=\"10\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-circle[data-number=\"11\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-circle[data-number=\"12\"] .photo-center-symbol {\n    width: 56px;\n    height: 56px;\n  }\n\n  .whot-playing-card--photo.shape-circle[data-number=\"13\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-circle[data-number=\"14\"] .photo-center-symbol {\n    width: 54px;\n    height: 54px;\n  }\n\n  .whot-playing-card--photo.shape-square[data-number=\"3\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"10\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"11\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"13\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"14\"] .photo-center-symbol {\n    width: 54px;\n    height: 54px;\n  }\n\n  .whot-playing-card--photo.shape-triangle[data-number=\"3\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"4\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"5\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"7\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"8\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"10\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"11\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"12\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"13\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"14\"] .photo-center-symbol {\n    width: 54px;\n    height: 54px;\n  }\n\n  .whot-playing-card--photo .photo-whot-text {\n    font-size: 1.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .whot-page {\n    padding: 10px;\n  }\n\n  .whot-playing-card {\n    width: 52px;\n    height: 74px;\n  }\n\n  .whot-playing-card.is-small {\n    width: 44px;\n    height: 62px;\n  }\n\n  .whot-table {\n    padding: 0.75rem;\n    min-height: 45vh;\n  }\n\n  .whot-table-center {\n    gap: 10px;\n  }\n\n  /* Horizontal scroll hand so lots of cards still fit */\n\n  .whot-hand {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    justify-content: flex-start;\n    padding: 0.3rem 0.5vw 0.5rem 0.5vw;\n    gap: 8px;\n    -webkit-overflow-scrolling: touch;\n    background: none;\n    box-shadow: none;\n    min-height: 0;\n  }\n\n  @media (max-width: 600px) {\n    .whot-hand {\n      position: sticky;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      z-index: 20;\n      background: rgba(30,40,80,0.97);\n      border-radius: 0;\n      box-shadow: 0 -2px 12px 0 rgba(0,0,0,0.12);\n      padding-bottom: env(safe-area-inset-bottom, 0.5rem);\n      margin-bottom: 0;\n    }\n    .whot-table {\n      padding-bottom: 80px;\n    }\n  }\n\n  .whot-hand > .whot-playing-card {\n    flex: 0 0 auto;\n  }\n\n  .whot-playing-card--photo .photo-corner-number {\n    font-size: 1rem;\n  }\n\n  .whot-playing-card--photo .photo-center-symbol {\n    width: 44px;\n    height: 44px;\n  }\n\n  .whot-playing-card--photo.shape-circle[data-number=\"10\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-circle[data-number=\"11\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-circle[data-number=\"12\"] .photo-center-symbol {\n    width: 40px;\n    height: 40px;\n  }\n\n  .whot-playing-card--photo.shape-circle[data-number=\"13\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-circle[data-number=\"14\"] .photo-center-symbol {\n    width: 40px;\n    height: 40px;\n  }\n\n  .whot-playing-card--photo.shape-square[data-number=\"3\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"10\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"11\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"13\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-square[data-number=\"14\"] .photo-center-symbol {\n    width: 40px;\n    height: 40px;\n  }\n\n  .whot-playing-card--photo.shape-triangle[data-number=\"3\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"4\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"5\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"7\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"8\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"10\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"11\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"12\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"13\"] .photo-center-symbol,\n  .whot-playing-card--photo.shape-triangle[data-number=\"14\"] .photo-center-symbol {\n    width: 40px;\n    height: 40px;\n  }\n\n  .whot-playing-card--photo .photo-whot-text {\n    font-size: 1.1rem;\n  }\n}\n\n/* a11y helper */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Card flight animation (deck → hand, hand → pile) */\n.whot-flight-layer {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 9999;\n}\n\n.whot-flight-card {\n  position: fixed;\n  transform-origin: top left;\n  will-change: transform, opacity;\n  filter: drop-shadow(0 12px 18px rgba(0, 0, 0, 0.35));\n}\n\n.whot-hand-card {\n  display: inline-block;\n}\n\n\n\n.whot-table {\n  background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);\n  border-radius: 20px;\n  padding: 1.2rem;\n  position: relative;\n  min-height: 50vh;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n}\n\n.whot-table-corner {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  display: grid;\n  gap: 1px;\n  padding: 4px 8px;\n  border-radius: 10px;\n  background: rgba(8, 12, 35, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);\n  z-index: 2;\n}\n\n.whot-table-corner-title {\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.whot-table-corner-value {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: #f8fafc;\n}\n\n.whot-table-corner-timer {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #93c5fd;\n}\n\n.whot-table-left-banner {\n  position: absolute;\n  top: 52%;\n  left: -2px;\n  transform: translateY(-50%);\n  z-index: 2;\n  padding: 4px 8px;\n  font-size: 0.8rem;\n  max-width: 180px;\n  pointer-events: none;\n}\n\n@media (max-width: 900px) and (orientation: landscape) {\n  .whot-table-corner {\n    top: 40%;\n    left: 6px;\n    transform: translateY(-50%);\n    padding: 3px 6px;\n  }\n\n  .whot-table-corner-value {\n    font-size: 0.85rem;\n  }\n\n  .whot-table-corner-timer {\n    font-size: 0.75rem;\n  }\n\n  .whot-table-left-banner {\n    top: 56%;\n    left: -4px;\n    font-size: 0.75rem;\n    transform: translateY(-50%);\n    max-width: 155px;\n  }\n\n  .whot-table .whot-controls {\n    position: absolute;\n    top: 44%;\n    right: 8px;\n    transform: translateY(-50%);\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n    background: transparent;\n    padding: 0;\n  }\n\n  .whot-control-btn {\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .whot-btn-text {\n    display: none;\n  }\n\n  .whot-btn-icon {\n    display: inline-flex;\n    width: 18px;\n    height: 18px;\n  }\n\n  .whot-controls .whot-pick-banner {\n    display: none;\n  }\n}\n\n.whot-btn-icon {\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  color: currentColor;\n}\n\n.whot-btn-text {\n  display: none;\n}\n\n.whot-table-center {\n  margin-top: 14px;\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.whot-turn-indicator {\n  min-width: 120px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.95);\n  font-weight: 900;\n  font-size: 1.35rem;\n  letter-spacing: 0.02em;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.55);\n  user-select: none;\n}\n\n@media (max-width: 768px) {\n  .whot-turn-indicator {\n    min-width: 96px;\n    font-size: 1.15rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .whot-turn-indicator {\n    min-width: 84px;\n    font-size: 1.05rem;\n  }\n}\n\n.whot-table-playzone {\n  margin-top: 10px;\n}\n\n.whot-card--in-table {\n  padding: 10px;\n  box-shadow: none;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.whot-table .whot-hand {\n  padding: 0.65rem 0.5rem;\n  gap: 8px;\n}\n\n.whot-deck {\n  width: 100px;\n  height: 140px;\n  background: linear-gradient(135deg, #3b82f6, #8b5cf6);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.whot-deck::after {\n  content: 'WHOT';\n  color: white;\n  font-size: 1.35rem;\n  font-weight: 900;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.whot-deck-count {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.35);\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-weight: 800;\n}\n\n.whot-hand {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 0.5rem;\n  background: rgba(0, 0, 0, 0.25);\n  border-radius: var(--whot-radius);\n  margin-top: 14px;\n}\n\n/* Preview page */\n.whot-preview-grid {\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(75px, 1fr));\n  gap: 12px;\n}\n\n.whot-preview-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.whot-preview-caption {\n  font-size: 12px;\n  color: rgba(248, 250, 252, 0.75);\n  text-align: center;\n}\n\n@media (max-width: 480px) {\n  .whot-preview-grid {\n    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\n    gap: 10px;\n  }\n}\n\n.whot-shape-options {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n.whot-shape-option {\n  width: 46px;\n  height: 46px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  cursor: pointer;\n  color: white;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.whot-muted {\n  color: rgba(248, 250, 252, 0.75);\n}\n\n.whot-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.whot-scoreboard {\n  margin-top: 14px;\n  padding: 14px;\n  border-radius: var(--whot-radius);\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.whot-score-list {\n  margin-top: 10px;\n  display: grid;\n  gap: 8px;\n}\n\n.whot-score-item {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.whot-score-item--rank-1 {\n  border-color: rgba(34, 197, 94, 0.6);\n  background: rgba(34, 197, 94, 0.12);\n}\n\n.whot-score-item--rank-2 {\n  border-color: rgba(251, 191, 36, 0.5);\n  background: rgba(251, 191, 36, 0.12);\n}\n\n/* WHOT lobby board polish */\n.whot-lobby-create {\n  background: linear-gradient(145deg, rgba(15, 23, 42, 0.72), rgba(17, 24, 39, 0.68));\n}\n\n.whot-lobby-limit {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(2, 6, 23, 0.35);\n}\n\n.whot-lobby-section {\n  padding: 14px;\n}\n\n.whot-lobby-room {\n  background: rgba(2, 6, 23, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n}\n\n/* Redesigned WHOT lobby layout */\n.whot-lobby-container {\n  min-height: 100vh;\n  position: relative;\n  overflow-x: clip;\n  padding: 22px;\n  background: radial-gradient(900px 480px at 10% -5%, rgba(139, 92, 246, 0.25), transparent 60%),\n    radial-gradient(700px 420px at 92% 4%, rgba(16, 185, 129, 0.18), transparent 60%),\n    linear-gradient(140deg, #0b1223, #121b2e);\n}\n\n.whot-lobby-container {\n  color: #f8fafc;\n}\n\n.whot-lobby-container h1,\n.whot-lobby-container h2,\n.whot-lobby-container h3,\n.whot-lobby-container h4,\n.whot-lobby-container p,\n.whot-lobby-container span,\n.whot-lobby-container label,\n.whot-lobby-container strong,\n.whot-lobby-container button {\n  color: inherit;\n}\n\n.whot-lobby-container,\n.whot-lobby-container *,\n.whot-lobby-container *::before,\n.whot-lobby-container *::after {\n  box-sizing: border-box;\n}\n\n.whot-bg-animation {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.whot-card-glow {\n  position: absolute;\n  width: 320px;\n  height: 320px;\n  border-radius: 999px;\n  filter: blur(75px);\n  opacity: 0.4;\n  left: -70px;\n  top: 18%;\n  background: rgba(139, 92, 246, 0.7);\n  animation: whot-lobby-float 14s ease-in-out infinite;\n}\n\n.whot-card-glow.delay-1 {\n  left: auto;\n  right: -90px;\n  top: -40px;\n  background: rgba(14, 165, 233, 0.64);\n  animation-delay: 3s;\n}\n\n.whot-card-glow.delay-2 {\n  left: 45%;\n  top: 72%;\n  width: 260px;\n  height: 260px;\n  background: rgba(16, 185, 129, 0.54);\n  animation-delay: 6s;\n}\n\n@keyframes whot-lobby-float {\n  0%, 100% { transform: translate3d(0, 0, 0) scale(1); }\n  50% { transform: translate3d(20px, -16px, 0) scale(1.06); }\n}\n\n.whot-lobby-content {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  gap: 18px;\n}\n\n.whot-lobby-content > * {\n  width: 100%;\n  min-width: 0;\n}\n\n.whot-lobby-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.whot-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  font-size: 24px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.whot-lobby-title {\n  margin: 0;\n  font-size: clamp(1.45rem, 2.8vw, 2rem);\n}\n\n.whot-lobby-subtitle {\n  margin: 4px 0 0;\n  color: rgba(248, 250, 252, 0.76);\n}\n\n.sound-toggle {\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  cursor: pointer;\n}\n\n.stats-cards,\n.quick-actions-grid,\n.challenges-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.stats-cards {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.stat-card,\n.quick-actions-section,\n.create-section,\n.challenges-section,\n.create-modal {\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(7, 12, 24, 0.74);\n  backdrop-filter: blur(8px);\n}\n\n.stat-card {\n  padding: 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.stat-label { color: rgba(248, 250, 252, 0.74); font-size: 12px; }\n.stat-value { font-weight: 800; font-size: 1.1rem; }\n\n.error-alert {\n  border-radius: 12px;\n  border: 1px solid rgba(239, 68, 68, 0.6);\n  background: rgba(239, 68, 68, 0.12);\n  color: #fecaca;\n  padding: 10px 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.error-close {\n  margin-left: auto;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.quick-actions-section,\n.create-section,\n.challenges-section {\n  padding: 16px;\n}\n\n.quick-actions-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.challenges-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n\n.section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.section-title {\n  margin: 0;\n  font-size: 1.18rem;\n}\n\n.section-subtitle {\n  margin: 0;\n  color: rgba(248, 250, 252, 0.72);\n  font-size: 0.94rem;\n}\n\n.action-card {\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.05);\n  color: #eef2ff;\n  padding: 12px;\n  min-width: 0;\n}\n\n.action-card:not(.join-code) {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n}\n\n.action-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.16);\n  flex: 0 0 auto;\n}\n\n.action-info {\n  min-width: 0;\n}\n\n.action-title {\n  font-weight: 700;\n}\n\n.action-desc {\n  margin-top: 2px;\n  color: rgba(248, 250, 252, 0.72);\n  font-size: 0.88rem;\n}\n\n.action-card.quick-match { background: linear-gradient(140deg, rgba(16, 185, 129, 0.22), rgba(16, 185, 129, 0.08)); }\n.action-card.cancel-match { background: linear-gradient(140deg, rgba(239, 68, 68, 0.24), rgba(239, 68, 68, 0.09)); }\n\n.join-code { display: grid; gap: 8px; }\n.join-input { width: 100%; }\n.join-btn { width: 100%; }\n\n.code-input,\n.filter-select,\n.search-input,\n.form-input,\n.form-select {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(2, 6, 23, 0.48);\n  color: #f8fafc;\n  padding: 10px 12px;\n}\n\n.filter-select,\n.form-select {\n  color-scheme: dark;\n}\n\n.filter-select option,\n.form-select option {\n  background: #0f172a;\n  color: #f8fafc;\n}\n\n.code-hint,\n.form-hint {\n  color: rgba(191, 219, 254, 0.85);\n  font-size: 0.84rem;\n}\n\n.create-cards {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.create-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f8fafc;\n  padding: 12px;\n  text-align: left;\n}\n\n.create-card.real {\n  border-color: rgba(250, 204, 21, 0.45);\n}\n\n.create-title {\n  font-weight: 700;\n}\n\n.create-desc {\n  color: rgba(248, 250, 252, 0.74);\n  font-size: 0.88rem;\n}\n\n.limit-warning {\n  margin-top: 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(245, 158, 11, 0.45);\n  background: rgba(245, 158, 11, 0.12);\n  padding: 10px 12px;\n  color: #fde68a;\n}\n\n.challenge-card {\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(2, 6, 23, 0.36);\n  padding: 12px;\n  min-width: 0;\n}\n\n.challenge-header,\n.challenge-actions,\n.filters-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.challenge-stats {\n  margin-top: 8px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n/* Keep WHOT lobby room stats readable even when global .stat styles are loaded */\n.whot-lobby-container .challenge-stats .stat {\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 10px;\n  padding: 8px 10px;\n  text-align: left;\n}\n\n.whot-lobby-container .challenge-stats .stat .stat-label {\n  color: rgba(226, 232, 240, 0.88);\n  font-size: 0.78rem;\n}\n\n.whot-lobby-container .challenge-stats .stat .stat-value {\n  color: #f8fafc;\n  font-size: 0.96rem;\n  font-weight: 800;\n}\n\n.whot-lobby-container .challenge-stats .stat .stat-value.highlight {\n  color: #fde68a;\n}\n\n.challenge-rules,\n.challenge-host {\n  margin-top: 8px;\n  color: rgba(226, 232, 240, 0.82);\n  font-size: 0.9rem;\n}\n\n.challenge-badge {\n  border-radius: 999px;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.challenge-badge.friendly {\n  background: rgba(56, 189, 248, 0.2);\n  color: #7dd3fc;\n}\n\n.challenge-badge.real {\n  background: rgba(239, 68, 68, 0.2);\n  color: #fecaca;\n}\n\n.action-btn {\n  border: none;\n  border-radius: 10px;\n  padding: 8px 12px;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.12);\n  cursor: pointer;\n}\n\n.action-btn.play { background: linear-gradient(140deg, #22c55e, #16a34a); }\n.action-btn.watch { background: linear-gradient(140deg, #38bdf8, #0284c7); }\n.action-btn.cancel { background: linear-gradient(140deg, #ef4444, #b91c1c); }\n\n.action-btn.disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.modal-container {\n  width: min(760px, calc(100vw - 18px));\n  max-height: min(90vh, 880px);\n  overflow: auto;\n  border-radius: 16px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  background: linear-gradient(165deg, #0f172a 0%, #111827 55%, #0b1220 100%);\n  color: #f8fafc;\n}\n\n.modal-container .form-select,\n.modal-container .filter-select {\n  background-color: #0f172a !important;\n  color: #f8fafc !important;\n}\n\n.modal-container .form-select option,\n.modal-container .filter-select option {\n  background-color: #0f172a !important;\n  color: #f8fafc !important;\n}\n\n.modal-container .form-label,\n.modal-container .form-hint,\n.modal-container .rule-checkbox,\n.modal-container .rule-checkbox span,\n.modal-container .form-input,\n.modal-container .form-select,\n.modal-container .form-input::placeholder {\n  color: #f8fafc;\n}\n\n.modal-header,\n.modal-footer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px;\n}\n\n.modal-header {\n  border-bottom: 1px solid rgba(148, 163, 184, 0.22);\n}\n\n.modal-body {\n  padding: 14px;\n  display: grid;\n  gap: 10px;\n}\n\n.whot-create-modal .modal-body {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: start;\n}\n\n.whot-create-modal .modal-body .form-group--full {\n  grid-column: 1 / -1;\n}\n\n.modal-title {\n  margin: 0;\n}\n\n.modal-close {\n  margin-left: auto;\n  border: none;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.btn-create,\n.btn-cancel {\n  border: none;\n  border-radius: 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n}\n\n.btn-create {\n  flex: 2;\n  background: linear-gradient(140deg, #22c55e, #16a34a);\n  color: #fff;\n  font-weight: 800;\n}\n\n.btn-cancel {\n  flex: 1;\n  background: linear-gradient(140deg, #ef4444, #b91c1c);\n  color: #fff;\n}\n\n.empty-state {\n  border-radius: 12px;\n  border: 1px dashed rgba(148, 163, 184, 0.4);\n  background: rgba(15, 23, 42, 0.4);\n  padding: 20px;\n  text-align: center;\n}\n\n.empty-title {\n  margin-top: 6px;\n  font-weight: 800;\n}\n\n.empty-desc {\n  margin-top: 4px;\n  color: rgba(226, 232, 240, 0.75);\n}\n\n.challenge-list { display: grid; gap: 10px; }\n\n.room-card {\n  border-radius: 14px;\n  padding: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(2, 6, 23, 0.36);\n}\n\n.room-header,\n.room-meta,\n.room-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.room-meta,\n.room-rules {\n  margin-top: 6px;\n  color: rgba(226, 232, 240, 0.78);\n  font-size: 0.92rem;\n}\n\n.room-actions { margin-top: 10px; }\n\n.mode-badge,\n.status-badge,\n.section-badge {\n  border-radius: 999px;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.mode-badge.friendly { background: rgba(56, 189, 248, 0.18); color: #7dd3fc; }\n.mode-badge.real { background: rgba(239, 68, 68, 0.18); color: #fca5a5; }\n.status-badge.open { background: rgba(16, 185, 129, 0.2); color: #86efac; }\n.status-badge.full { background: rgba(245, 158, 11, 0.2); color: #fcd34d; }\n\n.create-modal {\n  max-width: 860px;\n  width: min(860px, calc(100vw - 20px));\n}\n\n.create-kind-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.kind-tab {\n  flex: 1;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.06);\n  color: #e2e8f0;\n  padding: 8px;\n}\n\n.kind-tab.active {\n  background: linear-gradient(140deg, rgba(139, 92, 246, 0.36), rgba(99, 102, 241, 0.2));\n  border-color: rgba(167, 139, 250, 0.8);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.rules-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.rule-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 900px) {\n  .whot-lobby-content {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .stats-cards,\n  .quick-actions-grid,\n  .challenges-grid,\n  .challenge-stats,\n  .create-cards,\n  .form-grid,\n  .rules-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .whot-lobby-container {\n    padding: 12px;\n  }\n\n  .whot-create-modal .modal-body {\n    grid-template-columns: 1fr;\n  }\n\n  .whot-lobby-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .filters-bar {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Bright text overrides for redesigned lobby */\n.whot-lobby-container .form-input,\n.whot-lobby-container .form-select,\n.whot-lobby-container .code-input,\n.whot-lobby-container .filter-select,\n.whot-lobby-container .search-input,\n.whot-lobby-container .join-input,\n.whot-lobby-container .join-btn,\n.whot-lobby-container .rules-value,\n.whot-lobby-container .challenge-host,\n.whot-lobby-container .challenge-rules,\n.whot-lobby-container .form-hint,\n.whot-lobby-container .code-hint,\n.whot-lobby-container .empty-desc {\n  color: #f8fafc;\n}\n\n.whot-lobby-container .form-input::placeholder,\n.whot-lobby-container .code-input::placeholder,\n.whot-lobby-container .search-input::placeholder {\n  color: rgba(226, 232, 240, 0.85);\n}\n\n.whot-lobby-room-head {\n  padding-bottom: 4px;\n  border-bottom: 1px dashed rgba(255, 255, 255, 0.15);\n}\n\n.whot-lobby-mode-badge {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.whot-lobby-mode-badge.is-real {\n  color: #fecaca;\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.5);\n}\n\n.whot-lobby-mode-badge.is-friendly {\n  color: #bbf7d0;\n  background: rgba(34, 197, 94, 0.2);\n  border: 1px solid rgba(34, 197, 94, 0.45);\n}\n\n.whot-lobby-room-actions .whot-btn {\n  min-width: 88px;\n}\n\n.whot-create-choice {\n  border: none;\n  color: #ffffff;\n}\n\n.whot-create-choice--bot {\n  background: linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%);\n}\n\n.whot-create-choice--friendly {\n  background: linear-gradient(135deg, #10b981 0%, #0f766e 100%);\n}\n\n.whot-create-choice--real {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.whot-create-choice:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.25);\n}\n\n.whot-create-choice:disabled {\n  opacity: 0.55;\n}\n\n.whot-lobby-modal {\n  background: linear-gradient(165deg, #0f172a 0%, #111827 55%, #0b1220 100%);\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  box-shadow: 0 28px 70px rgba(2, 6, 23, 0.75);\n  color: #e5e7eb;\n}\n\n.whot-lobby-modal .modal-header {\n  background: linear-gradient(120deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.22);\n}\n\n.whot-lobby-modal .modal-body {\n  display: grid;\n  gap: 10px;\n}\n\n.whot-lobby-modal .modal-header h3 {\n  margin: 0;\n  color: #f8fafc;\n}\n\n.whot-lobby-modal .close-btn {\n  color: #cbd5e1;\n}\n\n.whot-lobby-modal .close-btn:hover {\n  background: rgba(148, 163, 184, 0.18);\n  color: #f8fafc;\n}\n\n.whot-lobby-modal .modal-footer {\n  background: rgba(15, 23, 42, 0.82);\n  border-top: 1px solid rgba(148, 163, 184, 0.22);\n}\n\n.whot-lobby-modal .whot-modal-create-btn {\n  order: 1;\n  flex: 2;\n  min-height: 44px;\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.whot-lobby-modal .whot-modal-create-btn:hover:not(:disabled) {\n  box-shadow: 0 10px 22px rgba(34, 197, 94, 0.28);\n}\n\n.whot-lobby-modal .whot-modal-create-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.whot-lobby-modal .whot-modal-cancel-btn {\n  order: 2;\n  flex: 1;\n  min-height: 44px;\n  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.whot-lobby-modal .whot-modal-cancel-btn:hover {\n  box-shadow: 0 8px 18px rgba(239, 68, 68, 0.25);\n}\n\n.whot-lobby-modal .form-group {\n  margin-bottom: 14px;\n}\n\n.whot-lobby-modal .whot-wager-group {\n  border: 1px solid rgba(250, 204, 21, 0.45);\n  background: rgba(250, 204, 21, 0.1);\n  border-radius: 12px;\n  padding: 10px;\n}\n\n.whot-lobby-modal .whot-wager-group .form-label {\n  color: #fde68a;\n}\n\n.whot-lobby-modal .whot-wager-input {\n  border: 1px solid rgba(250, 204, 21, 0.7) !important;\n  background: rgba(15, 23, 42, 0.9) !important;\n  background-color: rgba(15, 23, 42, 0.9) !important;\n  color: #f8fafc !important;\n  -webkit-text-fill-color: #f8fafc !important;\n  caret-color: #f8fafc !important;\n  font-weight: 700;\n  font-size: 1.02rem;\n  opacity: 1 !important;\n  box-shadow: none !important;\n  appearance: textfield;\n  -moz-appearance: textfield;\n  color-scheme: dark;\n}\n\n.whot-lobby-modal .whot-wager-input::placeholder {\n  color: rgba(254, 240, 138, 0.9);\n}\n\n.whot-lobby-modal input[type=\"number\"].whot-wager-input::-webkit-outer-spin-button,\n.whot-lobby-modal input[type=\"number\"].whot-wager-input::-webkit-inner-spin-button {\n  opacity: 1;\n}\n\n.whot-lobby-modal .whot-wager-input:-webkit-autofill,\n.whot-lobby-modal .whot-wager-input:-webkit-autofill:hover,\n.whot-lobby-modal .whot-wager-input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #f8fafc !important;\n  -webkit-box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.9) inset !important;\n  box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.9) inset !important;\n  background-color: rgba(15, 23, 42, 0.9) !important;\n}\n\n.whot-lobby-modal .form-group > label {\n  color: #e2e8f0;\n  font-weight: 700;\n}\n\n.whot-lobby-modal .whot-input {\n  background: rgba(15, 23, 42, 0.9) !important;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  color: #f8fafc !important;\n}\n\n.whot-lobby-modal .whot-input:focus {\n  border-color: rgba(96, 165, 250, 0.85);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n}\n\n.whot-lobby-modal .whot-input::placeholder {\n  color: rgba(203, 213, 225, 0.85);\n}\n\n.whot-lobby-modal select.whot-input option {\n  background: #0f172a;\n  color: #f8fafc;\n}\n\n.whot-lobby-modal .whot-input:disabled {\n  background: rgba(30, 41, 59, 0.9) !important;\n  color: #94a3b8 !important;\n  opacity: 1;\n}\n\n/* Keep friend datalist input readable across browser default/autofill styling. */\n.whot-lobby-modal .whot-input[list] {\n  background: rgba(15, 23, 42, 0.9) !important;\n  color: #f8fafc !important;\n  border-color: rgba(148, 163, 184, 0.55);\n}\n\n.whot-lobby-modal .whot-input[list]::placeholder {\n  color: rgba(203, 213, 225, 0.85);\n}\n\n.whot-lobby-modal .whot-input[list]:disabled {\n  background: rgba(30, 41, 59, 0.9) !important;\n  color: #94a3b8 !important;\n  opacity: 1;\n}\n\n.whot-lobby-modal .whot-input[list]:-webkit-autofill,\n.whot-lobby-modal .whot-input[list]:-webkit-autofill:hover,\n.whot-lobby-modal .whot-input[list]:-webkit-autofill:focus {\n  -webkit-text-fill-color: #f8fafc;\n  -webkit-box-shadow: 0 0 0 1000px #0f172a inset;\n  box-shadow: 0 0 0 1000px #0f172a inset;\n}\n\n.whot-lobby-modal small {\n  color: #94a3b8;\n}\n\n.whot-house-rules-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.whot-house-rule-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.9);\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  color: #f8fafc;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.whot-house-rule-item input {\n  accent-color: #38bdf8;\n}\n\n.whot-lobby-alert {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(127, 29, 29, 0.35);\n  border: 1px solid rgba(248, 113, 113, 0.55);\n  color: #fee2e2;\n  font-weight: 600;\n}\n\n.whot-lobby-alert--modal {\n  margin-bottom: 6px;\n  background: rgba(127, 29, 29, 0.45);\n}\n\n@media (max-width: 768px) {\n  .whot-page--lobby {\n    padding: 8px;\n  }\n\n  .whot-page--lobby .whot-shell {\n    max-width: 100%;\n  }\n\n  .whot-page--lobby .whot-header {\n    margin-bottom: 12px;\n  }\n\n  .whot-page--lobby .whot-title {\n    font-size: 22px;\n  }\n\n  .whot-page--lobby .whot-card {\n    padding: 10px;\n    border-radius: 12px;\n  }\n\n  .whot-page--lobby .whot-lobby-room {\n    padding: 10px !important;\n  }\n\n  .whot-lobby-create-actions .whot-btn {\n    flex: 1 1 100%;\n  }\n\n  .whot-lobby-quick-row .whot-input {\n    min-width: 100%;\n  }\n\n  .whot-house-rules-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.whot-turn-alert {\n  margin: 10px 0 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  background: rgba(15, 23, 42, 0.35);\n  color: rgba(241, 245, 249, 0.95);\n  font-weight: 700;\n  text-align: center;\n}\n\n.whot-turn-alert.is-active {\n  border-color: rgba(34, 197, 94, 0.75);\n  background: rgba(22, 163, 74, 0.2);\n  animation: whotTurnPulse 1.1s ease-in-out infinite;\n}\n\n.cm-start-spotlight--whot {\n  gap: 8px;\n  margin: 10px auto 8px;\n  padding: 10px 14px;\n  max-width: 320px;\n  border-radius: 14px;\n  background:\n    radial-gradient(circle at top, rgba(251, 191, 36, 0.12), transparent 56%),\n    rgba(15, 23, 42, 0.72);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2);\n}\n\n.cm-start-spotlight--whot .cm-start-spotlight__title {\n  font-size: 0.82rem;\n}\n\n.cm-start-spotlight--whot .cm-start-spotlight__sub {\n  font-size: 0.72rem;\n  line-height: 1.35;\n}\n\n.cm-start-spotlight--whot .cm-btn--start-compact {\n  min-width: 0;\n  padding: 9px 16px;\n  font-size: 0.82rem;\n  font-weight: 800;\n  border-radius: 999px;\n  box-shadow: 0 8px 18px rgba(251, 191, 36, 0.18);\n}\n\n.whot-opponent-panel--active {\n  /* Removed large box yellow border */\n}\n\n.whot-opponent-panel--active .whot-opponent-head strong {\n  color: #facc15;\n  text-shadow: 0 0 8px rgba(250, 204, 21, 0.6);\n}\n\n.whot-opponent-panel--active .whot-opponent-fan {\n  filter: drop-shadow(0 -4px 8px rgba(250, 204, 21, 0.4));\n}\n\n.whot-hand--active-turn {\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.7);\n}\n\n.whot-hand-card {\n  transition: transform 120ms ease, opacity 120ms ease;\n  position: relative;\n}\n\n.whot-hand-card:hover,\n.whot-hand-card:focus-within {\n  z-index: 10;\n}\n\n.whot-hand-card--dragging {\n  opacity: 0.65;\n  transform: translateY(-8px);\n}\n\n@keyframes whotTurnPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);\n  }\n}\n\n@media (max-width: 600px) {\n  .cm-start-spotlight--whot {\n    margin: 8px auto 6px;\n    padding: 9px 12px;\n    max-width: calc(100% - 20px);\n  }\n\n  .cm-start-spotlight--whot .cm-btn--start-compact {\n    width: auto;\n    padding: 8px 14px;\n    font-size: 0.78rem;\n  }\n}\n\n/* Weekly Leaderboard Styles */\n.weekly-leaderboard {\n  background: rgba(30, 41, 59, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 16px;\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.weekly-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.weekly-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0;\n  color: #facc15;\n}\n\n.refresh-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.1rem;\n  transition: transform 0.3s;\n}\n\n.refresh-btn:hover {\n  transform: rotate(180deg);\n}\n\n.weekly-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.weekly-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 12px;\n  transition: all 0.2s;\n}\n\n.weekly-item:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.weekly-rank {\n  font-weight: 800;\n  width: 24px;\n  text-align: center;\n}\n\n.weekly-player {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.player-name {\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.player-wins {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.weekly-points {\n  font-weight: 700;\n  color: #10b981;\n}\n\n.weekly-points small {\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.weekly-footer {\n  margin-top: 16px;\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.3);\n  text-align: center;\n}\n\n.weekly-loader, .weekly-error {\n  text-align: center;\n  padding: 20px;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.rank-1 { border-left: 3px solid #facc15; background: rgba(250, 204, 21, 0.05); }\n.rank-2 { border-left: 3px solid #cbd5e1; background: rgba(203, 213, 225, 0.05); }\n.rank-3 { border-left: 3px solid #d97706; background: rgba(217, 119, 6, 0.05); }\n\r\n\n/* Weekly Leaderboard Modal & Trigger */\n.leaderboard-trigger {\n  background: rgba(250, 204, 21, 0.15);\n  border: 1px solid rgba(250, 204, 21, 0.4);\n  color: #facc15;\n  padding: 8px 16px;\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.leaderboard-trigger:hover {\n  background: rgba(250, 204, 21, 0.25);\n  transform: translateY(-1px);\n}\n\n.leaderboard-modal {\n  max-width: 500px;\n}\n\n.weekly-leaderboard-content {\n  padding: 8px 4px;\n}\n\n.weekly-score-main {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 60px;\n  background: rgba(16, 185, 129, 0.1);\n  padding: 6px;\n  border-radius: 10px;\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.score-value {\n  font-size: 1.2rem;\n  font-weight: 900;\n  color: #10b981;\n  line-height: 1;\n}\n\n.score-label {\n  font-size: 0.65rem;\n  font-weight: 800;\n  color: rgba(16, 185, 129, 0.8);\n  margin-top: 2px;\n}\n\n.player-points-detail {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.5);\n  margin-top: 2px;\n}\n\n.grid-full {\n  width: 100%;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 600px) {\n  .section-header {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .leaderboard-trigger {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
